define('viewmodels/RiskRating/RiskRatingResponsePage',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'services/utils', 'viewmodels/landing', 'viewmodels/survey/SurveyTracking', 'viewmodels/GeneralSettings'],
    function (ko, router, appsecurity, navigation, app, logger, system, utils, SurveyDashBoard, SurveyTrackingVM, ObjGeneralSettings) {

        var RRResponseVM = {
            activate: activate,
            detached: detached,
            canActivate: ko.observable(true),
            attached: attached,
            appsecurity: appsecurity,
            utils: utils,
            SurveyDashBoard: SurveyDashBoard,
            SurveyTrackingVM: SurveyTrackingVM,
            ObjGeneralSettings: ObjGeneralSettings,

            PageHeaderName: ko.observable(),

        /*Methods*/
            ExportSurveyToExcel: ExportSurveyToExcel,
            finalizeQuestionnairePopUp: finalizeQuestionnairePopUp,
            finalizeQuestionnaire: finalizeQuestionnaire,
            DownloadDocument: DownloadDocument,
            UploadDocument: UploadDocument,
            showOverallSummaryDiv: showOverallSummaryDiv,
            RunSyncRatings: RunSyncRatings,
            SyncRatings: SyncRatings,
            DeleteDocument: DeleteDocument,
            DeleteDocComments: DeleteDocComments,
            saveEventId: ko.observable(),
            showSurveyInfoClick: showSurveyInfoClick,
            ImportExcelPopUp: ImportExcelPopUp,
            UploadExcelDocument: UploadExcelDocument,
            ShowCommentsPopUp: ShowCommentsPopUp,
            SetDocumentComments: SetDocumentComments,
            SaveResponse: SaveResponse,
            GetUsersRoleWFDetails: GetUsersRoleWFDetails,
            showWFDescription: showWFDescription,
            PerformFinalizeAction: PerformFinalizeAction,

            SaveComment: SaveComment,
            CancelComment: CancelComment,
            OcKeypress: OcKeypress,
            OcKeyUp: OcKeyUp,
            ToggleNavigation: ToggleNavigation,
           ShowUploadDocumentsPopUp: ShowUploadDocumentsPopUp,
            EditQuestionComment: EditQuestionComment,
            DeleteQuestionComment: DeleteQuestionComment,
            GetCommentsPopUp: GetCommentsPopUp,
            SelectedActionEventId: ko.observable(),
            SummaryUploadProgressMessage: ko.observable(''),
            SummaryCommentCreatedDate: ko.observable(),
            SummaryCommentBy: ko.observable(),
            ProductName: ko.observable(),
            PushbackComment: ko.observable(),

            SurveySummaryComment: ko.observable(),
            SurveySummaryCommentId: ko.observable(),
            AccessFlagSyncRatingsInherent: ko.observable(false),
            readOnlyFlag: ko.observable(),
            TimelineCommentsFlag: ko.observable(true),
            SummaryDocumentsList: ko.observableArray([]),
            EnableMandatoryFlags: ko.observable(false),
            SurveyLevelMandatoryList: ko.observableArray([]),
            SurveyTimelineComments: ko.observableArray([]),
            PopOverCommentList: ko.observableArray([]),
            UsersRoleWFList: ko.observableArray([]),
            FinalizeValidationList: ko.observableArray([]),
            UploadComment: ko.observable(''),
            ProgressMessage: ko.observable(''),
            ProgressPercent: ko.observable(),

            ResponseCommentsList: ko.observableArray([]),
            UploadDocumentsList: ko.observable([]),
            RemainingChars: ko.observable(4000),
            CommentCharsLimit: ko.observable(4000),

       /*End*/
            RoleId: ko.observable(),
            Role: ko.observable(),
            ResponseComment: ko.observable(),
            selectedTreeNode: ko.observable(),
            IsSurveyCompleted: ko.observable(),
            IsSurveyPending: ko.observable(),
            CurrentCommentID: ko.observableArray([]),
            isSaveResponseClick: ko.observable(false),
            SurveyIconClass: ko.observable(),
            SurveyStateColor: ko.observable(),
            ClickedRiskFactorId: ko.observable(),
            SurveyProfileId: ko.observable(),
            SurveyTypeId: ko.observable(),
            ClickedRiskSubFactorName: ko.observable(),
            SurveyStatus: ko.observable(),
            SurveyProcessPoint: ko.observable(),
            SelectedQuestion: ko.observable(),
            SelectedQuestionId: ko.observable(),
            ResponseMoveArray: ko.observable(),
            ComponentName_Survey: ko.observable(),
            SelectedCommentType: ko.observable(''),
            ProfileName_Survey: ko.observable(),
            SurveyId: ko.observable(),
            SurveyName: ko.observable(),
            SurveyUsers: ko.observable(),
            DisableControl: ko.observable(false),
            IsCommentPopUp: ko.observable(false),
            IsDocumentPopUp: ko.observable(false),
            NavigateToDashboardBoolean: ko.observable(false),
            SurveyColumnDetails: ko.observable(),
            SurveyResponseList: ko.observable(),
            SurveyPendingWith: ko.observable(),
            SurveyCompletionPercentage: ko.observable(),
            SurveyActionsList: ko.observableArray([]),
            SurveyClassification: ko.observable(),
            UserList: ko.observable(),
            DueDate: ko.observable(),
            PendingWith: ko.observable(),
            // Previous Page
            PreviousPage: ko.observable(),
            // Survey
            hasChildNodes: ko.observable(false),
            ValuesChanged: ko.observable(),
            AreaLeveljstree: ko.observableArray([]),
            CurrentFactorId: ko.observable(),
            NavigatedFromTracking: ko.observable(false),
            NavigatedFromDashboard: ko.observable(),
            InitiateLevelTree: InitiateLevelTree,
            NavigateToDashboard: NavigateToDashboard,
            CurrentProfileOfAssessmentId: ko.observable(),

            SyncRatingsButtonDisable: ko.observable(false),
            SyncRatingsStatus: SyncRatingsStatus,
            ScheduledJobStatusList: ko.observableArray([]),
            firstLoad: ko.observable(true),
            IsSurveyReadOnly: ko.observable(),

        };

        return RRResponseVM;

        function detached() {
            try {
                RRResponseVM.canActivate(true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function activate() {
            try {
                RRResponseVM.AccessFlagSyncRatingsInherent((RRResponseVM.appsecurity.PageList() == undefined) ? false : (RRResponseVM.appsecurity.PageList().indexOf('CalculateResultsPCS') >= 0) ? true : false);
                if (RRResponseVM.SurveyTrackingVM.RoutedFrom() == "Tracking") {
                    RRResponseVM.PreviousPage("tracking");

                    RRResponseVM.SurveyId(RRResponseVM.SurveyTrackingVM.ResponseMoveArray().SurveyId());
                    //RRResponseVM.SurveyTypeId(RRResponseVM.Administration.ResponseMoveArray().GroupShortName());
                    RRResponseVM.readOnlyFlag(true);
                    RRResponseVM.SurveyName(RRResponseVM.SurveyTrackingVM.ResponseMoveArray().SurveyName());
                   RRResponseVM.SurveyProfileId(RRResponseVM.SurveyTrackingVM.ResponseMoveArray().SurveyProfileId());
                   
                    //  RRResponseVM.AssessmentTypeId(RRResponseVM.Administration.ResponseMoveArray().RatId());
                    RRResponseVM.DisableControl(true);
                    RRResponseVM.NavigatedFromTracking(true);
                    RRResponseVM.NavigatedFromDashboard(false);
                    $('#Import').attr('display', 'none');
                    $('#syncRatingsBtn').css('display', 'none');
                    RRResponseVM.appsecurity.WriteAccess(false);
                    RRResponseVM.SurveyIconClass(RRResponseVM.SurveyTrackingVM.ResponseMoveArray().SurveyIconClass());
                    RRResponseVM.DueDate(RRResponseVM.SurveyTrackingVM.ResponseMoveArray().DueDate());
                    RRResponseVM.SurveyStatus(RRResponseVM.SurveyTrackingVM.ResponseMoveArray().SurveyStatus());
                    RRResponseVM.PendingWith(RRResponseVM.SurveyTrackingVM.ResponseMoveArray().PendingAt());
                    RRResponseVM.CurrentProfileOfAssessmentId(RRResponseVM.SurveyTrackingVM.ResponseMoveArray().CurrentProfileOfAssessmentId());//ratid
                    RRResponseVM.UserList(RRResponseVM.SurveyTrackingVM.ResponseMoveArray().UserList());

                }

                else if (RRResponseVM.SurveyDashBoard.ResponseMoveArray() != undefined) {
                        RRResponseVM.NavigatedFromTracking(false);
                        RRResponseVM.NavigatedFromDashboard(true);
                      
                    if (RRResponseVM.SurveyDashBoard.ResponseMoveArray().IsSurveyReadOnly()) {
                        RRResponseVM.DisableControl(true);
                        RRResponseVM.appsecurity.WriteAccess(false);
                    }
                    else if (RRResponseVM.SurveyDashBoard.ResponseMoveArray().IsCompletedFlag()) {
                        RRResponseVM.DisableControl(true);
                        RRResponseVM.appsecurity.WriteAccess(false);
                    }
                    else {
                        RRResponseVM.appsecurity.WriteAccess(true);
                        RRResponseVM.DisableControl(false);
                    }


                        $('#Import').show();
                        $('#syncRatingsBtn').css('display', 'block');
                        RRResponseVM.SurveyProfileId(RRResponseVM.SurveyDashBoard.ResponseMoveArray().SurveyProfileId());
                        RRResponseVM.ProfileName_Survey(RRResponseVM.SurveyDashBoard.ResponseMoveArray().ProfileName_Survey());
                        RRResponseVM.SurveyId(RRResponseVM.SurveyDashBoard.ResponseMoveArray().SurveyId());
                        RRResponseVM.SurveyTypeId('QTDR');
                        RRResponseVM.Role(RRResponseVM.SurveyDashBoard.ResponseMoveArray().RoleName());
                        RRResponseVM.RoleId(RRResponseVM.SurveyDashBoard.ResponseMoveArray().RoleId())
                        RRResponseVM.SurveyName(RRResponseVM.SurveyDashBoard.ResponseMoveArray().SurveyName());
                        RRResponseVM.ComponentName_Survey(RRResponseVM.SurveyDashBoard.ResponseMoveArray().ComponentName_Survey());
                        RRResponseVM.DueDate(RRResponseVM.SurveyDashBoard.ResponseMoveArray().DueDate());
                        RRResponseVM.SurveyStatus(RRResponseVM.SurveyDashBoard.ResponseMoveArray().SurveyStatus());
                        RRResponseVM.SurveyIconClass(RRResponseVM.SurveyDashBoard.ResponseMoveArray().SurveyIconClass());
                        RRResponseVM.PendingWith(RRResponseVM.SurveyDashBoard.ResponseMoveArray().PendingWith());
                        RRResponseVM.SurveyStateColor(RRResponseVM.SurveyDashBoard.ResponseMoveArray().SurveyStateColor());
                        RRResponseVM.UserList(RRResponseVM.SurveyDashBoard.ResponseMoveArray().UserList());
                        RRResponseVM.CurrentProfileOfAssessmentId(RRResponseVM.SurveyDashBoard.ResponseMoveArray().CurrentProfileOfAssessmentId());
                        RRResponseVM.IsSurveyReadOnly(RRResponseVM.SurveyDashBoard.ResponseMoveArray().IsSurveyReadOnly());


                    }
                
                else if (RRResponseVM.SurveyDashBoard == undefined && RRResponseVM.SurveyDashBoard.ResponseMoveArray() == undefined) {
                    router.navigate("Landing", true);
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {
                InitiateLevelTree();
                if (RRResponseVM.SurveyTrackingVM.RoutedFrom().toLowerCase() == "tracking") {

                    RRResponseVM.PreviousPage(RRResponseVM.SurveyTrackingVM.RoutedFrom()); // To store the previous page

                    if (RRResponseVM.SurveyTrackingVM.ResponseMoveArray() == undefined) {
                        router.navigate("survey/SurveyTracking", true);
                    }
                    else {

                        RRResponseVM.SurveyTrackingVM.RoutedFrom(""); // So that it is empty for next iteration
                    }

                }

                else if (RRResponseVM.SurveyDashBoard.RoutedFrom().toLowerCase() == "dashboard") {
                    if (RRResponseVM.SurveyDashBoard.ResponseMoveArray() == undefined || RRResponseVM.SurveyDashBoard.ResponseMoveArray().length == 0) {
                        RRResponseVM.SurveyDashBoard.NavigatedFrom('Response');
                        router.navigate("#Landing", true);
                    }
                    else {

                        //RRResponseVM.DashboardVM.RoutedFrom(""); // So that it is empty for next iteration
                    }
                    RRResponseVM.PreviousPage(RRResponseVM.SurveyDashBoard.RoutedFrom()); // To stoore the previous page
                    GetUsersRoleWFDetails();
                    

                    RRResponseVM.firstLoad(true);

                    if (!RRResponseVM.IsSurveyCompleted())
                        SyncRatingsStatus(data, event);

                
            }
                RRResponseVM.firstLoad(false);
               
                //GetUsersRoleWFDetails();
                RRResponseVM.ValuesChanged(false);
                RRResponseVM.NavigateToDashboardBoolean(false);
               
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }
        function OcKeypress(data, event) {
            try {
                if (event.which === 16 || event.which === 17 || event.which === 18 || event.which === 35 || event.which === 36 || event.which === 46 || event.which === 8 || (event.which >= 112 && event.which <= 123))
                    return true;
                else {
                    if (event.currentTarget.value.length >= RRResponseVM.CommentCharsLimit()) {
                        return false;
                    }
                    return true;
                }
            }
            catch (e) {
                var msg = 'exception' + e + 'source in OcKeypress() in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function RunSyncRatings() {
            app.showMessage("Do you want to initiate the calculations to determine the ratings? ", "Run Calculations", [" Yes", " No"], true, { buttonClass: "btn primary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                .then(function (option) {
                    if (option == ' Yes') {
                        SyncRatings();
                    }
                    // Else we don't do anything
                });
        }

        function SyncRatings() {
            try {
                RRResponseVM.SyncRatingsButtonDisable(true);
                logger.logSuccess('Calculations have been initiated', 'Success', system.getModuleId(RRResponseVM), true);
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/SyncRatingsRR?SurveyId=" + RRResponseVM.SurveyId() +
                        "&JobType=CALCULATION-PCS-SYNC&AssessmentProfile=" + appsecurity.CurrentProfileOfAssessmentId(),
                    headers: headers,
                    type: "POST"
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult == 1) {
                            logger.logSuccess('Calculations have been completed.', 'Success', system.getModuleId(RRResponseVM), true);
                            RRResponseVM.SyncRatingsButtonDisable(false);
                        }
                        else if (jsonResult == 0)
                            logger.logError('An error has occurred while syncing the ratings. Please contact your Administrator.', 'Error', system.getModuleId(RRResponseVM), true);
                            RRResponseVM.SyncRatingsButtonDisable(false);
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError('An error has occurred while syncing the ratings. Please contact your Administrator.', 'Error', system.getModuleId(RRResponseVM), true);
                        RRResponseVM.SyncRatingsButtonDisable(false);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SyncRatings() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }


        function SyncRatingsStatus(data, event) {
            try {
                $('#syncRatingsBtn').prop('disabled', true);
                $('#loadingImgUser').show().addClass("d-inline-flex");
                // $('#LoadingGIFSRDiv').modal('show');

                $('#SyncRatingsRefreshBtn').hide();
                var FirstLoad = RRResponseVM.firstLoad();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/SyncRatingsStatus?SurveyId=" + RRResponseVM.SurveyId() +
                        "&JobType=CALCULATION-PCS-SYNC",
                    headers: headers,
                    type: "GET"
                }).success(function (jsonResult, error) {
                    if (jsonResult != null) {
                        // Use this after the get call if the json result = 1
                        var MappedScheduledJobStatus = $.map(jsonResult, function (result) {
                            return new JobStatusModel(result);
                        });
                        RRResponseVM.ScheduledJobStatusList(MappedScheduledJobStatus);
                        if (RRResponseVM.ScheduledJobStatusList()[0].JobRunStatus === "In-Progress") {
                            RRResponseVM.SyncRatingsButtonDisable(true);
                            logger.logWarning('Calculations Still in Progress', 'Error', system.getModuleId(RRResponseVM), true);
                            $('#loadingImgUser').hide().removeClass("d-inline-flex").addClass("d-none");
                            $('#SyncRatingsRefreshBtn').show();
                        }
                        else {
                            RRResponseVM.SyncRatingsButtonDisable(false);
                            //$('#syncRatingsBtn').prop('disabled', false);
                            if (FirstLoad != true)
                                logger.logSuccess('Calculations have been completed. Click on the desired area to check the ratings.', 'Error', system.getModuleId(RRResponseVM), true);

                            RRResponseVM.isSaveResponseClick(true);
                            RRResponseVM.saveEventId(event.currentTarget.id);
                            RRResponseVM.selectedTreeNode($('#jsTreeAreaLevel').treeview('getSelected'));

                            // refreshing the treeview along with new data load

                            $('#jsTreeAreaLevel').treeview('selectNode', [RRResponseVM.selectedTreeNode()[0].nodeId, { silent: true }]);

                            RRResponseVM.ClickedRiskFactorId(parseInt(RRResponseVM.selectedTreeNode()[0].id));
                            RRResponseVM.ProductName(RRResponseVM.selectedTreeNode()[0].text);
                            GetSurveyColumnDetails().then(function () {
                                BindSurveyTable();
                            });
                            $('#loadingMainImgDivFactors').show();
                        }
                    }
                    else if (jsonResult == null) {
                        logger.logError('An error has occurred while fetching the status of the calculations. Please contact your Administrator.', 'Error', system.getModuleId(RRResponseVM), true);
                        $('#loadingImgUser').hide().removeClass("d-inline-flex").addClass("d-none");
                        $('#SyncRatingsRefreshBtn').show();
                        $('#syncRatingsBtn').prop('disabled', false);
                    }
                    $('#LoadingGIFSRDiv').modal('hide');

                }).fail(function (jsonResult, error) {
                    $('#LoadingGIFSRDiv').modal('hide');
                    logger.logError('An error has occurred while syncing the ratings. Please contact your Administrator.', 'Error', system.getModuleId(RRResponseVM), true);
                    $('#loadingImgUser').hide().removeClass("d-inline-flex").addClass("d-none");
                    $('#SyncRatingsRefreshBtn').show();
                    $('#syncRatingsBtn').prop('disabled', false);
                });
            }
            catch (e) {
                $('#LoadingGIFSRDiv').modal('hide');
                var msg = 'Exception: ' + e + ' | Source: SyncRatingsStatus() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }



        function OcKeyUp(data, event) {
            try {
                RRResponseVM.RemainingChars(RRResponseVM.CommentCharsLimit() - event.currentTarget.value.length);
            }
            catch (e) {
                var msg = 'exception' + e + 'source in OcKeypress() in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ShowCommentsPopUp(data, event) {
            try {
                RRResponseVM.ClickedRiskSubFactorName(data.RRItemName());
                $('#lblNoResponseComment').hide();
                RRResponseVM.IsCommentPopUp(true);
                RRResponseVM.SelectedQuestion(data);
                RRResponseVM.SelectedQuestionId(data.RRItemId());
                $('#lblRCError_' + data.RRItemId()).hide();
                RRResponseVM.ResponseCommentsList([]);
                //showCommentsRichText(RRResponseVM.SelectedQuestionId(), 'cmt');
                RRResponseVM.ResponseComment('');
              //  RRResponseVM.IsReadOnlyQuestion(data.IsReadOnly());
                if (RRResponseVM.DisableControl() == false || RRResponseVM.appsecurity.WriteAccess()) {
                    document.getElementById("ResponseTextArea_" + data.RRItemId()).value = '';
                }
                RRResponseVM.RemainingChars(RRResponseVM.CommentCharsLimit());
                GetCommentsPopUp(data.RRItemId(), "RC", null).then(function () {
                    $('#ResponseCommentPopUp').modal('show');
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowCommentsPopUp() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SaveComment(questionId, data, event) {
            try {
                //var comment = CKEDITOR.instances["ResponseTextArea_" + questionId].getData();
                //RRResponseVM.ResponseComment(comment);

                RRResponseVM.ResponseComment($("#ResponseTextArea_" + RRResponseVM.SelectedQuestionId()).val().trim());
                var lblRCError = 'lblRCError_' + RRResponseVM.SelectedQuestionId();
                if (RRResponseVM.ResponseComment() !== "" && RRResponseVM.ResponseComment() != undefined) {
                    if (RRResponseVM.ResponseComment().length <= RRResponseVM.CommentCharsLimit()) {
                        document.getElementById(lblRCError).innerHTML = "";
                        $('#' + lblRCError).hide();

                            SetComments(RRResponseVM.SelectedQuestionId(), "RC", RRResponseVM.ResponseComment());


                    }
                    else {
                        document.getElementById(lblRCError).innerHTML = "The response comment should not exceed " + RRResponseVM.CommentCharsLimit() + " characters.";
                        $('#' + lblRCError).show();
                        //$('#saveCommentBtn_' + questionId).attr('disabled', false);
                    }
                    //showCommentsRichText(RRResponseVM.SelectedQuestionId(), 'cmt');
                }
                else {
                    document.getElementById(lblRCError).innerHTML = "The response comment cannot be left blank.";
                    $('#' + lblRCError).show();
                    //$('#saveCommentBtn_' + questionId).attr('disabled', false);
                }
                RRResponseVM.RemainingChars(RRResponseVM.CommentCharsLimit());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveComment() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }
        function SetComments(QuestionId, Type, CommentText) {
            try {
                RRResponseVM.selectedTreeNode($('#jsTreeAreaLevel').treeview('getSelected'));
                var ResponseId = "";
                var CommentId = 0;
                    ResponseId = 0;

                if (RRResponseVM.CurrentCommentID() !== null) {
                    CommentId = RRResponseVM.CurrentCommentID();
                }
                //if (Type == "NC") {
                //    ResponseId = 0;
                //}
                RRResponseVM.SelectedCommentType(Type);
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingDashboard/SetSurveyComments",
                    type: "POST",
                    headers: headers,
                    data: {
                        QuestionId: QuestionId, CommentType: Type, CommentText: CommentText, SPR_UID: RRResponseVM.SurveyId(),
                        CommentId: CommentId, RoleId: RRResponseVM.RoleId()
                    }
                    //async: false
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in SetComments() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    RRResponseVM.ResponseComment('');
                    document.getElementById("ResponseTextArea_" + QuestionId).value = null;
                    if (jsonResult !== null) {
                        //if (Type === "NC") {
                        //    logger.logSuccess('Comment saved successfully.', 'Success', system.getModuleId(RRResponseVM), true);
                        //}
                        if (jsonResult <= 0) {
                            //logger.logError('An error occurred while saving Comments. Please contact your Application Administrator.', 'Error', system.getModuleId(RRResponseVM), true);
                            var redirectBack = confirm("You are no longer allowed to perform Save/Edit operation. The Survey is either moved to another state or picked by another user. You will be redirected to Landing Page.");
                            if (redirectBack === true) {
                                RRResponseVM.SurveyDashBoard.NavigatedFrom('Response');
                                router.navigate("landing", true);
                            }
                            else {
                                app.showMessage("The Survey is either moved to another state or picked by another user. You are not allowed to perform Save/Edit operation. Please click 'OK' to redirect to Landing Page.", "Action cannot be performed", [" OK"], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                                    .then(function (option) {
                                        if (option === " OK") {
                                            RRResponseVM.SurveyDashBoard.NavigatedFrom('Response');
                                            router.navigate("landing", true);
                                        }
                                    });
                            }
                        }
                        else if (jsonResult === 0 && Type !== "PBC") {
                            logger.logError('An error occurred while saving Comments. Because Comment contain some invalid characters.', 'Error', system.getModuleId(RRResponseVM), true);
                        }
                        else {
                            if (Type === "RC" || Type === "RC-CD") {


                                ko.utils.arrayFilter(RRResponseVM.SurveyResponseList(), function (item) {
                                    if (item.RRItemId() == RRResponseVM.SelectedQuestionId()) {
                                        item.CommentCount(jsonResult);
                                    }
                                });
                                    logger.logSuccess('Comments have been saved successfully.', 'Success', system.getModuleId(RRResponseVM), true);
                                    //GetQuantitativeTableCommentCount();

                                   if (RRResponseVM.IsCommentPopUp())
                                        GetCommentsPopUp(QuestionId, Type, null);

                                      GetComments(QuestionId, Type, null);


                                RRResponseVM.isSaveResponseClick(true);
                               // SegregatorBasedOnSurveyType();
                            }
                        }
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RRResponseVM), true);

                    $('#saveCommentBtn').attr('disabled', false);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SetComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SetComments() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in SetComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };
        }
        function GetComments(QuestionId, Type, ResponseId) {
            try {

                return $.ajax({
                    url: "/api/RiskRatingDashboard/GetSurveyComments",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { QuestionId: QuestionId, surveyProfileRelId: RRResponseVM.SurveyId(), ResponseId: ResponseId, CommentType: Type, SurveyType: RRResponseVM.SurveyTypeId().toUpperCase() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetComments() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {

                    RRResponseVM.DocumentListFinal([]);
                    RRResponseVM.CurrentCommentID([]);
                    $('#ResponseId' + QuestionId).attr('disabled', false);
                    if (jsonResult == null) {
                        // no comments fetched
                    }
                    else if (jsonResult.surveyCommentModel.length == 0) {
                        RRResponseVM.SurveyCompletionPercentage(jsonResult.SurveyCompletionPercentage);
                        if (Type == 'RD') {
                            var docListPopUp = "";
                            docListPopUp += '<p id="lbldocResponseComment" class="nodatamessage">There are no Attachments available.</p>'

                            $('#doc_cmt_List_' + QuestionId).html("");
                            $('#doc_cmt_List_' + QuestionId).html(docListPopUp);
                        }

                        var commentListPopUp = "";
                        commentListPopUp += '<span id="lblNoResponseComment" class="nodatamessage">There are no Comments available.</span>'

                        $('#cmt_List_' + QuestionId).html("");
                        $('#cmt_List_' + QuestionId).html(commentListPopUp);
                    }
                    else if (jsonResult != null && jsonResult.surveyCommentModel.length != 0) {
                        if (Type == 'RD') {
                            RRResponseVM.SurveyCompletionPercentage(jsonResult.SurveyCompletionPercentage);

                            var Mapped = $.map(jsonResult.surveyCommentModel, function (result) {
                                return new DocumentCommentModel(result);
                            });
                            RRResponseVM.DocumentListFinal(Mapped);
                            if (RRResponseVM.DocumentListFinal().length > 0) {
                                var documentListPopUp = "";
                                documentListPopUp += ' <h6 class="card-title">All Attachments</h6>';
                                for (k = 0; k < RRResponseVM.DocumentListFinal().length > 0; k++) {
                                    documentListPopUp += '<div class="col-lg-12 atachmentSubBox">';
                                    documentListPopUp += '<span><i class="demo-icon icon-paperclip_special"></i> ' + RRResponseVM.DocumentListFinal()[k].DocumentName() + '</span>';

                                    documentListPopUp += '<p class="bg-white col-lg-12 mb-1">' + RRResponseVM.DocumentListFinal()[k].DCommentText() + '</p>';
                                    documentListPopUp += '<input type="text" id="copydoccmtBox_' + RRResponseVM.DocumentListFinal()[k].DCommentId() + '" style="display:none;" value="' + RRResponseVM.DocumentListFinal()[k].DCommentText() + '">';
                                    documentListPopUp += '<span class="font-weight-bold mr-2 mb-3">' + RRResponseVM.DocumentListFinal()[k].DUploadedBy() + '</span>'
                                    documentListPopUp += ' on  <span>' + RRResponseVM.DocumentListFinal()[k].DUploadedDate() + '</span>';

                                    documentListPopUp += '<span class="c-actions" title="Download Document" id= "downdoc_' + RRResponseVM.DocumentListFinal()[k].DCommentId() + '" data-bind="click: function (data,event) { $root.DownloadDocument}"><i class="demo-icon icon-download_special"></i> Download</span>';
                                    documentListPopUp += '<span class="c-actions" title="Copy Document Comment" id= "copydoccmt_' + RRResponseVM.DocumentListFinal()[k].DCommentId() + '" data-bind="click: function (data,event) { $root.CopyComment}"><i class="demo-icon icon-copy_special"></i> Copy</span>';
                                    if (RRResponseVM.DocumentListFinal()[k].DIsCurrentUser() === "1" && RRResponseVM.IsReadOnlyQuestion() === 0 && RRResponseVM.IsConditionalQuestion() == 0 && (!RRResponseVM.DisableControl() || RRResponseVM.appsecurity.WriteAccess())) {
                                        documentListPopUp += '<span class="c-actions" title="Delete Document" id= "deldoc_' + RRResponseVM.DocumentListFinal()[k].DCommentId() + '" data-bind="click: function (data,event)  { $root.DeleteDocument($root.DocumentListFinal()[' + k + '] ,\'RD\') }"><i class="demo-icon icon-bin_special"></i> Delete</span>';
                                    }
                                    documentListPopUp += '</div>';
                                }

                                $('#doc_cmt_List_' + QuestionId).html("");
                                $('#doc_cmt_List_' + QuestionId).html(documentListPopUp);

                                for (k = 0; k < RRResponseVM.DocumentListFinal().length > 0; k++) {
                                    ko.applyBindingsToNode($('#downdoc_' + RRResponseVM.DocumentListFinal()[k].DCommentId()), { click: RRResponseVM.DownloadDocument }, RRResponseVM.DocumentListFinal()[k]);
                                    ko.applyBindingsToNode($('#copydoccmt_' + RRResponseVM.DocumentListFinal()[k].DCommentId()), { click: RRResponseVM.CopyComment }, 'copydoccmtBox_' + RRResponseVM.DocumentListFinal()[k].DCommentId());
                                    if (RRResponseVM.DocumentListFinal()[k].DIsCurrentUser() === "1" && RRResponseVM.IsReadOnlyQuestion() === 0 && RRResponseVM.IsConditionalQuestion() == 0 && (!RRResponseVM.DisableControl() || RRResponseVM.appsecurity.WriteAccess())) {
                                        ko.applyBindingsToNode($('#deldoc_' + RRResponseVM.DocumentListFinal()[k].DCommentId()), { click: RRResponseVM.DeleteDocument }, RRResponseVM.DocumentListFinal()[k]);
                                    }
                                }
                            }
                        }
                        else {
                            var MappedColumnObject = $.map(jsonResult.surveyCommentModel, function (result) {
                                return new CommentModel(result);
                            })
                            if (Type === 'RC')
                                RRResponseVM.SurveyCompletionPercentage(jsonResult.SurveyCompletionPercentage);

                            RRResponseVM.PopOverCommentList([]);
                            RRResponseVM.PopOverCommentList(MappedColumnObject);
                            var commentListPopUp = "";
                            if (RRResponseVM.PopOverCommentList().length == 0)
                                commentListPopUp += '<span id="lblNoResponseComment" class="nodatamessage">There are no Comments available.</span>'
                            else {
                                commentListPopUp += ' <h6 class="card-title">All Comments</h6>';
                                for (k = 0; k < RRResponseVM.PopOverCommentList().length > 0; k++) {
                                    commentListPopUp += '<div class="comment-view"><div class="cbox"><span class="tip tip-down"></span><div class="message">'
                                    commentListPopUp += RRResponseVM.PopOverCommentList()[k].CommentText();
                                    commentListPopUp += '</div></div></div>'

                                    var commentText = RRResponseVM.PopOverCommentList()[k].CommentText().substring(RRResponseVM.PopOverCommentList()[k].CommentText().indexOf(":") + 1);
                                    commentText = $('<div/>').html(commentText).text().trim();

                                    commentListPopUp += '<input type="text" id="copycmtBox_' + RRResponseVM.PopOverCommentList()[k].CommentId() + '" style="display:none;" value="' + commentText + '">';
                                    commentListPopUp += '<span class="commenter">' + RRResponseVM.PopOverCommentList()[k].UploadedBy() + '</span>';
                                    commentListPopUp += ' on <span class="cdate">' + RRResponseVM.PopOverCommentList()[k].UploadedDate() + '</span>';
                                    commentListPopUp += '<span class="c-actions" title="Copy Comment" id= "copycmt_' + RRResponseVM.PopOverCommentList()[k].CommentId() + '" data-bind="click: function (data,event) { $root.CopyComment}"><i class="demo-icon icon-copy_special"></i> Copy</span>'
                                    if (RRResponseVM.PopOverCommentList()[k].IsCurrentUser() === "1" && RRResponseVM.IsReadOnlyQuestion() === 0 && RRResponseVM.IsConditionalQuestion() == 0 && (!RRResponseVM.DisableControl() || RRResponseVM.appsecurity.WriteAccess())) {
                                        commentListPopUp += '<span class="c-actions" title="Edit Comment" id= "editcmt_' + RRResponseVM.PopOverCommentList()[k].CommentId() + '" data-bind="click: function (data,event) { $root.EditQuestionComment}"><i class="demo-icon icon-file_edit_special"></i> Edit</span>';
                                        commentListPopUp += '<span class="c-actions" title="Delete Comment" id= "deletecmt_' + RRResponseVM.PopOverCommentList()[k].CommentId() + '" data-bind="click: function (data,event) { $root.DeleteQuestionComment}"><i class="demo-icon icon-bin_special"></i>Delete</span>';
                                    }
                                }
                            }
                            $('#cmt_List_' + QuestionId).html("");
                            $('#cmt_List_' + QuestionId).html(commentListPopUp);

                            for (k = 0; k < RRResponseVM.PopOverCommentList().length > 0; k++) {
                                ko.applyBindingsToNode($('#copycmt_' + RRResponseVM.PopOverCommentList()[k].CommentId()), { click: RRResponseVM.CopyComment }, 'copycmtBox_' + RRResponseVM.PopOverCommentList()[k].CommentId());
                                if (RRResponseVM.PopOverCommentList()[k].IsCurrentUser() === "1" && RRResponseVM.IsReadOnlyQuestion() === 0 && RRResponseVM.IsConditionalQuestion() == 0 && (!RRResponseVM.DisableControl() || RRResponseVM.appsecurity.WriteAccess())) {
                                    ko.applyBindingsToNode($('#editcmt_' + RRResponseVM.PopOverCommentList()[k].CommentId()), { click: RRResponseVM.EditQuestionComment }, RRResponseVM.PopOverCommentList()[k]);
                                    ko.applyBindingsToNode($('#deletecmt_' + RRResponseVM.PopOverCommentList()[k].CommentId()), { click: RRResponseVM.DeleteQuestionComment }, RRResponseVM.PopOverCommentList()[k]);
                                }
                            }
                            $('#ResponseId' + QuestionId).prop('selectedIndex', 0);

                            //RRResponseVM.SelectedColumnId("");
                            if (RRResponseVM.SurveyTypeId().toUpperCase() == "QLDR" || RRResponseVM.SurveyTypeId().toUpperCase() == "CDR") {
                                $('#question-Section_' + QuestionId)[0].scrollTop = $('#question-Section_' + QuestionId)[0].scrollHeight;
                            }
                        }
                        RRResponseVM.RemainingChars(RRResponseVM.CommentCharsLimit());
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RRResponseVM), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetComments() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };
        }
        function ShowUploadDocumentsPopUp(data, event) {
            try {
                RRResponseVM.ClickedRiskSubFactorName(data.RRItemName());
                $('#lblRDError_' + data.RRItemId()).hide();
                $('#lblNoResponseDocument').hide();
                RRResponseVM.IsDocumentPopUp(true);
                RRResponseVM.SelectedQuestion(data);
                RRResponseVM.SelectedQuestionId(data.RRItemId());
                RRResponseVM.UploadDocumentsList([]);
                //showCommentsRichText(RRResponseVM.SelectedQuestionId(), 'atch');
                if (data.IsReadOnly() != 1 && (RRResponseVM.DisableControl() == false || RRResponseVM.appsecurity.WriteAccess())) {
                    document.getElementById('FileUploaderForDocuments_' + data.RRItemId()).value = '';
                    document.getElementById("UploadTextArea_" + data.RRItemId()).value = '';
                }
                RRResponseVM.UploadComment('');
               // RRResponseVM.IsReadOnlyQuestion(data.IsReadOnly());
                RRResponseVM.RemainingChars(RRResponseVM.CommentCharsLimit());
                GetCommentsPopUp(data.RRItemId(), "RD", null).then(function () {
                    $('#UploadDocumentPopUp').modal('show');
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowUploadDocumentsPopUp() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }
        function CommentModel(item) {
            try {
                var self = this;
                self.CommentText = ko.observable(item.CommentText);
                self.CommentId = ko.observable(item.CommentId);
                self.UploadedBy = ko.observable(item.UploadedBy);
                self.UploadedDate = ko.observable(item.UploadedDate);
                self.IsCurrentUser = ko.observable(item.IsCurrentUser);
                self.SurveyCompletionPercentage = ko.observable(item.SurveyCompletionPercentage);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CommentModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }
        function CancelComment(questionId, data, event) {
            try {
                $('#ResponseId' + questionId).attr('disabled', false);
                $('#ResponseId' + questionId).prop('selectedIndex', 0);
                RRResponseVM.CurrentCommentID('');
                if (data.IsReadOnly() != 1 && (RRResponseVM.DisableControl() == false || RRResponseVM.appsecurity.WriteAccess())) {

                        document.getElementById("ResponseTextArea_" + questionId).value = null;

                }
                RRResponseVM.RemainingChars(RRResponseVM.CommentCharsLimit());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CancelComment() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function showOverallSummaryDiv() {
            try {
                $('#OverallSummaryDiv').modal('show');
                GetSurveyLevelComments("SND");
                RRResponseVM.RemainingChars(RRResponseVM.CommentCharsLimit());
                //var editor = CKEDITOR.instances['NarrationTextArea'];
                //if (editor) {
                //    editor.destroy(true);
                //}
                //CKEDITOR.replace('NarrationTextArea', {
                //    removePlugins: RRResponseVM.RemovePlugins(),
                //    removeButtons: RRResponseVM.RemoveButtons()
                //});
                //CKEDITOR.instances['NarrationTextArea'].on('key', function () {
                //    ckeCharCheck();
                //});
                $('#NarrationTextArea').html(RRResponseVM.SurveySummaryComment());
                //ckeCharCheck();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showOverallSummaryDiv() method in SurveyResponsePage.js';

                logger.logMessage(msg);
            }
        }


        function GetQuantitativeTableCommentCount() {
            try {
                $.ajax({
                    url: "/api/RiskRatingDashboard/GetRRProductQuestionDetails",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { SurveyId: RRResponseVM.SurveyId(), FactorId: RRResponseVM.ClickedRiskFactorId() }
                })
                    .success(function (JsonResult, Success) {
                        var MappedResponses = $.map(JsonResult.QuanResponseModel, function (result) {
                            return new QuantitativeResponseModel(result);
                        });
                        RRResponseVM.SurveyResponseList(MappedResponses);
                        for (var i = 0; i < RRResponseVM.SurveyResponseList().length; i++) {
                            for (var j = 0; j < MappedResponses.length; j++)
                                if (RRResponseVM.SurveyResponseList()[i].QuestionId() == MappedResponses[j].QuestionId()) {
                                    RRResponseVM.SurveyResponseList()[i].CommentCount(MappedResponses[j].CommentCount());
                                }
                        }
                      //  setSurveyLevelMandatoryList();
                    })
                    .fail(function (fail, error) {

                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetQuantitativeTableCommentCount() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function finalizeQuestionnaire(data, event) {
            try {
                if (RRResponseVM.DisableControl() == false || RRResponseVM.appsecurity.WriteAccess()) {
                        finalizeQuestionnairePopUp(data, event);
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: finalizeQuestionnaire() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function finalizeQuestionnairePopUp(data, event) {
            try {
                RRResponseVM.PushbackComment('');
                RRResponseVM.TimelineCommentsFlag(true);
                $('#showCmpltTimelineBtn').hide();
                $('#showLessTimelineBtn').show();
                RRResponseVM.SurveyTimelineComments([]);
                $('#divActionError').hide();
                RRResponseVM.RemainingChars(RRResponseVM.CommentCharsLimit());

                if (RRResponseVM.SurveyDashBoard.RoutedFrom() === "Dashboard" && !RRResponseVM.IsSurveyPending() && !RRResponseVM.IsSurveyCompleted() && RRResponseVM.ValuesChanged() && (RRResponseVM.DisableControl() == false || RRResponseVM.appsecurity.WriteAccess())) {
                    app.showMessage("Please save the data before performing this action, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn", primaryButtonClass: "primary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                        .then(function (option) {
                            if (option === "Save") {
                                $('#SurveyTimelinePopUp').modal('hide');
                                RRResponseVM.SavechangedvalueTab(null);
                                RRResponseVM.SavechangedvalueSubTab(null);

                                    SaveResponse(RRResponseVM.SelectedNode());

                            }
                            GetSurveyAction().then(function () {
                                $('#FinalizeValidations').hide();
                                $('#SurveyTimelinePopUp').modal('show');
                            });
                        });
                }
                else {
                    if (RRResponseVM.DisableControl() == false || RRResponseVM.appsecurity.WriteAccess()) {
                        GetSurveyAction().then(function () {
                            $('#FinalizeValidations').hide();
                            $('#SurveyTimelinePopUp').modal('show');
                        });
                    }
                    else
                        GetSurveyLevelComments("PBC").then(function () {
                            $('#FinalizeValidations').hide();
                            $('#SurveyTimelinePopUp').modal('show');
                        });
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: finalizeQuestionnairePopUp() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function PerformFinalizeAction(data, event) {
            try {
                RRResponseVM.SelectedActionEventId('');
                if ($('input[name=rdbAction]:checked').val() === undefined) {
                    document.getElementById('lblActionError').innerHTML = "Please select an action to perform.";
                    $('#divActionError').show();
                }
                else if (RRResponseVM.PushbackComment().trim() === "" || RRResponseVM.PushbackComment() === undefined) {
                    document.getElementById('lblActionError').innerHTML = "Please enter survey finalize comment.";
                    $('#divActionError').show();
                }
                else {
                    if (RRResponseVM.PushbackComment().length > RRResponseVM.CommentCharsLimit()) {
                        document.getElementById('lblActionError').innerHTML = "Comment cannot exceed " + RRResponseVM.CommentCharsLimit() + " characters.";
                        $('#divActionError').show();
                        return;
                    }

                    var selectedAction = ko.utils.arrayFilter(RRResponseVM.SurveyActionsList(), function (param) {
                        return param.EventId() === $('input[name=rdbAction]:checked').val();
                    });
                    RRResponseVM.SelectedActionEventId(selectedAction[0].EventId());
                    var selectedOption = $('input[name=rdbAction]:checked').closest('label').text();
                    if (selectedAction[0] && selectedAction[0].ShowValidatePopup()) {

                        $('#divActionError').hide();
                        ValidateSurvey(selectedAction);
                    }
                    else {
                        $('#divActionError').hide();
                        SetSurveyLevelComments("PBC");
                    }
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: btnClickPerformAction() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }
        function GetSurveyAction() {
            try {
                return $.ajax({
                    url: "/api/RiskRatingDashboard/GetActionsList?TableType=PCS"  + "&TableId=" + RRResponseVM.SurveyId() + "&RoleId=" + RRResponseVM.RoleId(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetSurveyAction() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    RRResponseVM.SurveyActionsList([]);
                    $('#divActionError').hide();
                    if (jsonResult !== null) {
                        var mappedActionsList = $.map(jsonResult, function (result) {
                            return new SurveyActionsModel(result);
                        });
                        RRResponseVM.SurveyActionsList(mappedActionsList);
                        if (jsonResult.length === 1 && jsonResult[0].EventId === 0 && !RRResponseVM.IsSurveyCompleted()) {
                            document.getElementById('lblActionError').innerHTML = "No Actions are available.";
                            $('#divActionError').show();
                        }
                        $('#FinalizeCommentDiv').html("");
                        $('#FinalizeCommentDiv').html($('#FinalizeCommentsBlock').html());
                        $('#FinalizeCommentDiv').show();
                    }
                    else {
                        $('#FinalizeCommentDiv').hide();
                    }
                    GetSurveyLevelComments("PBC");
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetSurveyAction() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyAction() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetSurveyAction() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetSurveyLevelComments(commentType) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/GetSurveyLevelComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ Draft: RRResponseVM.SurveyId(), SurveyType: "PCS", CommentType: commentType, AssessmentProfileId: parseInt(RRResponseVM.CurrentProfileOfAssessmentId()) })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetSurveyLevelComments() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (commentType === "PBC") {
                        RRResponseVM.SurveyTimelineComments([]);
                        if (jsonResult !== "") {
                            var convertedObj = JSON.parse(jsonResult);
                            var mappedList = ko.mapping.fromJS(convertedObj.Comments)();
                            RRResponseVM.SurveyTimelineComments(mappedList);
                        }
                        else {
                            $('#showCmpltTimelineBtn').hide();
                            $('#showLessTimelineBtn').hide();
                        }
                    }
                    else if (commentType === "SN") {
                        if (jsonResult !== "") {
                            var summaryObj = JSON.parse(jsonResult);
                            var summaryComment = ko.mapping.fromJS(summaryObj.Comments)();
                            RRResponseVM.SurveySummaryCommentId(summaryComment[0].CommentId());
                            RRResponseVM.SurveySummaryComment("");
                            RRResponseVM.SurveySummaryComment(summaryComment[0].CommentText());
                            RRResponseVM.SummaryCommentBy(summaryComment[0].UserName());
                            RRResponseVM.SummaryCommentCreatedDate(summaryComment[0].CreateDate());
                        }
                        else {
                            RRResponseVM.SurveySummaryCommentId(0);
                            RRResponseVM.SurveySummaryComment('');
                            RRResponseVM.SummaryCommentBy('');
                            RRResponseVM.SummaryCommentCreatedDate('');
                        }
                    }
                    else if (commentType === "SND") {
                        RRResponseVM.SummaryDocumentsList([]);
                        if (jsonResult !== "") {
                            var docObj = JSON.parse(jsonResult);
                            var mappedDocList = ko.mapping.fromJS(docObj.Comments)();
                            RRResponseVM.SummaryDocumentsList(mappedDocList);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetSurveyLevelComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyLevelComments() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetSurveyLevelComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }
        function GetUsersRoleWFDetails() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    url: "/api/Configuration/GetRoleUserDetailsForBUSocializationWorkFLow",
                    data: ko.toJSON({
                        "SurveyId": RRResponseVM.SurveyId(),
                        "Survey_type": "PCS"
                    }),
                    type: "POST",
                    headers: headers
                })
                    .success(function (jsonResult, success) {
                        RRResponseVM.UsersRoleWFList([]);
                        if (jsonResult === null) {
                            $('#UsersRoleWFChevrons').hide();
                        }
                        if (jsonResult.length > 0 && jsonResult !== null) {
                            $('#UsersRoleWFChevrons').show();
                            RRResponseVM.UsersRoleWFList(jsonResult);
                        }
                    })
                    .fail(function (error, status) {
                        try {
                            if (error.status === 401) {
                                app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then(function (option) {
                                        if (option === "OK")
                                            navigation.unauthorized();
                                    });
                            }
                            else {
                                var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetUsersRoleWFDetails() method in SurveyResponsePage.js';
                                logger.logMessage(msg);
                            }
                        } catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetUsersRoleWFDetails() method in SurveyResponsePage.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in GetUsersRoleWFDetails() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function showWFDescription(data, event) {
            try {
                if ($('#WFDescDiv').is(':visible')) {
                    $('#WFDescDiv').hide();
                    $('#showWFDescBtn').show();
                    $('#hideWFDescBtn').hide();
                }
                else {
                    $('#WFDescDiv').show();
                    $('#hideWFDescBtn').show();
                    $('#showWFDescBtn').hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showWFDescription() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ValidateSurvey(selectedAction) {
            try {
                $.ajax({
                    url: "/api/RiskRatingDashboard/ValidateRRSurvey",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { SurveyId: RRResponseVM.SurveyId()}
                })
                    .success(function (JsonResult, Success) {
                        ValidationTblObj = $('#FinalizeValidationTable').DataTable();
                        ValidationTblObj.destroy();
                        $("#FinalizeValidationTable tbody tr").remove();
                        RRResponseVM.FinalizeValidationList([]);
                        if (JsonResult !== null) {
                            if (JsonResult.length > 0) {
                                var mappedValidationList = $.map(JsonResult, function (result) {
                                    return new ValidationListObject(result);
                                });
                                RRResponseVM.FinalizeValidationList(mappedValidationList);

                                $('#FinalizeValidationTable').DataTable({
                                    "aLengthMenu": [5, 10, 25, "All"],
                                    "iDisplayLength": 5,
                                    "aoColumnDefs": [{
                                        "width": "15%",
                                        "bSortable": true,
                                        "orderable": true
                                    },
                                    {
                                        "width": "70%",
                                        "bSortable": true,
                                        "orderable": true
                                    },
                                    {
                                        "width": "10%",
                                        "bSortable": true,
                                        "orderable": true
                                    }]
                                });
                            }
                            if (RRResponseVM.FinalizeValidationList().length > 0 && selectedAction[0].ShowValidatePopup() === true) {
                                $('#FinalizeValidations').show();
                                $('#ValidationAccordainClick').removeClass('collapsed');
                                $('#validationTableDiv').addClass('show');
                                RRResponseVM.SurveyLevelMandatoryList([]);
                                var arrayObjectMain = [];
                                for (var i = 0; i < RRResponseVM.FinalizeValidationList().length; i++) {
                                    arrayObjectMain.push({ QuestionId_Mandatory: RRResponseVM.FinalizeValidationList()[i].QuestionId(), Flag_Type: RRResponseVM.FinalizeValidationList()[i].MandatoryFieldFlag() });
                                }
                                //RRResponseVM.SurveyLevelMandatoryList(arrayObjectMain);
                                //if (RRResponseVM.ClickedRiskAreaId() !== -999) {
                                //    setMandatoryFlags();
                                //}
                            }
                            else {
                                $('#divActionError').hide();
                                $('#FinalizeValidations').hide();
                                SetSurveyLevelComments("PBC");
                            }
                        }
                        else {
                            $('#divActionError').hide();
                            $('#FinalizeValidations').hide();
                            SetSurveyLevelComments("PBC");
                        }
                    })
                    .fail(function (error, fail) {

                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ValidateSurvey() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function setSurveyLevelMandatoryList() {
            try {

                    var arrayObjectQuan = RRResponseVM.SurveyLevelMandatoryList();
                    for (var i = 0; i < RRResponseVM.SurveyResponseList().length; i++) {
                        if (RRResponseVM.SurveyResponseList()[i].Is_Header() !== 1) {
                                // Responses
                                var rowCheck = [];
                            rowCheck = ko.utils.arrayFilter(arrayObjectQuan, function (arr) {
                                if (arr.QuestionId_Mandatory === RRResponseVM.SurveyResponseList()[i].RRItemId() && arr.Flag_Type === 'R')
                                        return arr;
                                });
                                if (RRResponseVM.QuanResponseObject()[i].ShowQuestionMandatoryFlag()) {
                                    if (rowCheck.length === 0)
                                        arrayObjectQuan.push({ QuestionId_Mandatory: RRResponseVM.SurveyResponseList()[i].RRItemId(), Flag_Type: 'R' });
                                }
                                else {
                                    if (rowCheck.length > 0)
                                        ko.utils.arrayRemoveItem(arrayObjectQuan, rowCheck[0]);
                                }
                                // Comments
                                rowCheck = [];
                                rowCheck = ko.utils.arrayFilter(arrayObjectQuan, function (arr) {
                                    if (arr.QuestionId_Mandatory === RRResponseVM.SurveyResponseList()[i].RRItemId() && arr.Flag_Type === 'C')
                                        return arr;
                                });
                            if (RRResponseVM.QuanResponseObject()[i].Is_CommentMandatory() && RRResponseVM.SurveyResponseList()[i].CommentCount() === 0 && RRResponseVM.SurveyResponseList()[i].IsReadOnly() === 0) {
                                    if (rowCheck.length === 0)
                                        arrayObjectQuan.push({ QuestionId_Mandatory: RRResponseVM.SurveyResponseList()[i].RRItemId(), Flag_Type: 'C' });
                                }
                                else {
                                    if (rowCheck.length > 0)
                                        ko.utils.arrayRemoveItem(arrayObjectQuan, rowCheck[0]);
                                }
                                // Documents
                                rowCheck = [];
                                rowCheck = ko.utils.arrayFilter(arrayObjectQuan, function (arr) {
                                    if (arr.QuestionId_Mandatory === RRResponseVM.SurveyResponseList()[i].QuestionId() && arr.Flag_Type === 'D')
                                        return arr;
                                });
                            if (RRResponseVM.SurveyResponseList()[i].Is_DocumentMandatory() && RRResponseVM.SurveyResponseList()[i].DocumentCount() === 0 && RRResponseVM.SurveyResponseList()[i].IsReadOnly() === 0) {
                                    if (rowCheck.length === 0)
                                        arrayObjectQuan.push({ QuestionId_Mandatory: RRResponseVM.SurveyResponseList()[i].QuestionId(), Flag_Type: 'D' });
                                }
                                else {
                                    if (rowCheck.length > 0)
                                        ko.utils.arrayRemoveItem(arrayObjectQuan, rowCheck[0]);
                                }
                            }
                        }
                        RRResponseVM.SurveyLevelMandatoryList(arrayObjectQuan);

                    setMandatoryFlags();

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: setSurveyLevelMandatoryList() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function setMandatoryFlags() {
            try {
                for (var i = 0; i < RRResponseVM.SurveyResponseList().length; i++) {
                    RRResponseVM.SurveyResponseList()[i].IsSaveClicked_Response(false);
                    RRResponseVM.SurveyResponseList()[i].IsSaveClicked_Comment(false);
                    RRResponseVM.SurveyResponseList()[i].IsSaveClicked_Document(false);
                    for (var h = 0; h < RRResponseVM.SurveyLevelMandatoryList().length; h++) {
                        if (RRResponseVM.SurveyLevelMandatoryList()[h].QuestionId_Mandatory === RRResponseVM.SurveyResponseList()[i].RRItemId() && RRResponseVM.SurveyLevelMandatoryList()[h].Flag_Type === 'R')
                                RRResponseVM.SurveyResponseList()[i].IsSaveClicked_Response(true);
                            //if (RRResponseVM.SurveyLevelMandatoryList()[h].QuestionId_Mandatory === RRResponseVM.QuanResponseObject()[i].QuestionId() && RRResponseVM.SurveyLevelMandatoryList()[h].Flag_Type === 'C')
                            //    RRResponseVM.SurveyResponseList()[i].IsSaveClicked_Comment(true);
                            //if (RRResponseVM.SurveyLevelMandatoryList()[h].QuestionId_Mandatory === RRResponseVM.QuanResponseObject()[i].QuestionId() && RRResponseVM.SurveyLevelMandatoryList()[h].Flag_Type === 'D')
                            //    RRResponseVM.SurveyResponseList()[i].IsSaveClicked_Document(true);
                        }
                    }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: setMandatoryFlags() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SetSurveyLevelComments(commentType) {
            try {
                var eventId = -1;
                var commentId = -1;
                var commentText = '';

                if (commentType === 'PBC') {
                    eventId = parseInt(RRResponseVM.SelectedActionEventId());
                    commentText = RRResponseVM.PushbackComment();
                }
                if (commentType === 'SN') {
                    commentText = CKEDITOR.instances["NarrationTextArea"].getData();
                    commentId = parseInt(RRResponseVM.SurveySummaryCommentId());
                }

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/SetSurveyLevelComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        Draft: RRResponseVM.SurveyId(), AssessmentProfileId: parseInt(RRResponseVM.CurrentProfileOfAssessmentId()),
                        EventId: eventId, CommentId: commentId, RoleId: RRResponseVM.RoleId(), CommentText: commentText,
                        CommentType: commentType, SurveyType: "PCS"
                    }),
                    type: "POST",
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetSurveyLevelComments() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (commentType === 'PBC') {
                        if (jsonResult > 0)
                            PerformSurveyAction();
                        else {
                            document.getElementById('lblActionError').innerHTML = "Error occurred while saving comments. Please try again.";
                            $('#divActionError').show();
                            //logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RRResponseVM), true);
                            var redirectBack = confirm("You are no longer allowed to perform Save/Edit operation. The Survey is either moved to another state or picked by another user. You will be redirected to Landing Page.");
                            if (redirectBack === true) {
                                RRResponseVM.SurveyDashBoard.NavigatedFrom('Response');
                                router.navigate("landing", true);
                            }
                            else {
                                app.showMessage("The Survey is either moved to another state or picked by another user. You are not allowed to perform Save/Edit operation. Please click 'OK' to redirect to Landing Page.", "Action cannot be performed", [" OK"], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                                    .then(function (option) {
                                        if (option === " OK") {
                                            RRResponseVM.SurveyDashBoard.NavigatedFrom('Response');
                                            router.navigate("landing", true);
                                        }
                                    });
                            }
                        }
                    }
                    else if (commentType === 'SN') {
                        if (jsonResult > 0) {
                            logger.logSuccess('Summary details saved successfully.', 'Success', system.getModuleId(RRResponseVM), true);
                            GetSurveyLevelComments(commentType);
                        }
                        else {
                            //logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RRResponseVM), true);
                            var redirectBack = confirm("You are no longer allowed to perform Save/Edit operation. The Survey is either moved to another state or picked by another user. You will be redirected to Landing Page.");
                            if (redirectBack === true) {
                                RRResponseVM.SurveyDashBoard.NavigatedFrom('Response');
                                router.navigate("landing", true);
                            }
                            else {
                                app.showMessage("The Survey is either moved to another state or picked by another user. You are not allowed to perform Save/Edit operation. Please click 'OK' to redirect to Landing Page.", "Action cannot be performed", [" OK"], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                                    .then(function (option) {
                                        if (option === " OK") {
                                            RRResponseVM.SurveyDashBoard.NavigatedFrom('Response');
                                            router.navigate("landing", true);
                                        }
                                    });
                            }
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SetSurveyLevelComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SetSurveyLevelComments() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in SetSurveyLevelComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function PerformSurveyAction() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingDashboard/SetPerformAction?SurveyType=PCS" + "&EventId=" + $('input[name=rdbAction]:checked').val() + "&SurveyId=" + RRResponseVM.SurveyId(),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in PerformSurveyAction() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    if (jsonResult > 0) {
                        logger.logSuccess('Survey action performed successfully.', 'Success', system.getModuleId(RRResponseVM), true);
                        RRResponseVM.SurveyDashBoard.NavigatedFrom('Response');
                        setTimeout(router.navigate('Landing', true), 200);
                    }
                    else if (jsonResult < 0)
                        logger.logError('An error occurred while performing selected survey action.', 'Error', system.getModuleId(RRResponseVM), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in PerformSurveyAction() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in PerformSurveyAction() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in PerformSurveyAction() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }
        function ToggleNavigation() {
            if ($('#btnHideNavigation').is(':visible')) {
                $('#divNavigation').hide();
                $('#divContent').removeClass("col-md-9 sq-box");
                $('#divContent').addClass("col-md-12");
                $('#btnShowNavigation').show();
            }
            else {
                $('#btnShowNavigation').hide();
                $('#divContent').removeClass("col-md-12");
                $('#divContent').addClass("col-md-9 sq-box");
                $('#divNavigation').show();
            }
        }
        function showSurveyInfoClick(SurveyId, ProfileId) {
            try {
                if ($('#surveyInfoDiv_' + SurveyId + '_' + ProfileId).is(':visible')) {
                    $('#surveyInfoDiv_' + SurveyId + '_' + ProfileId).hide(500);
                    $('#surveyInfoDivMore_' + SurveyId + '_' + ProfileId).show();
                    $('#surveyInfoDivLess_' + SurveyId + '_' + ProfileId).hide();
                }
                else {
                    $('#surveyInfoDiv_' + SurveyId + '_' + ProfileId).show(500);
                    $('#surveyInfoDivLess_' + SurveyId + '_' + ProfileId).show();
                    $('#surveyInfoDivMore_' + SurveyId + '_' + ProfileId).hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showSurveyInfoClick() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }
        function GetCommentsPopUp(QuestionId, Type, ResponseId) {
            try {

                RRResponseVM.CurrentCommentID('');
                return $.ajax({
                    url: "/api/RiskRatingDashboard/GetSurveyComments",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { QuestionId: QuestionId, surveyProfileRelId: RRResponseVM.SurveyId(), ResponseId: ResponseId, CommentType: Type, SurveyType: RRResponseVM.SurveyTypeId().toUpperCase()}
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetCommentsPopUp() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult !== null) {
                        if (Type === "RC") {
                            RRResponseVM.ResponseCommentsList([]);
                            if (jsonResult.surveyCommentModel.length !== 0) {
                                var MappedColumnObject = $.map(jsonResult.surveyCommentModel, function (result) {
                                    return new CommentModel(result);
                                });
                                RRResponseVM.ResponseCommentsList(MappedColumnObject);
                            }
                            else {
                                $('#lblNoResponseComment').show();
                            }
                        }
                        else if (Type === "RD") {
                            RRResponseVM.UploadDocumentsList([]);
                            if (jsonResult.surveyCommentModel.length !== 0) {
                                var MappedDColumnObject = $.map(jsonResult.surveyCommentModel, function (result) {
                                    return new DocumentCommentModel(result);
                                });
                                RRResponseVM.UploadDocumentsList(MappedDColumnObject);
                            }
                            else {
                                $('#lblNoResponseDocument').show();
                            }
                        }
                    }
                    else {
                        if (Type === "RC")
                            $('#lblNoResponseComment').show();
                        else if (Type === "RD")
                            $('#lblNoResponseDocument').show();
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetCommentsPopUp() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetCommentsPopUp() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetCommentsPopUp() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function UploadDocument(data) {
            try {

                var Filelist = "";
                var FileName = "";
                var errormsgId = "";
                var ProgressBarMainDivId = "";
                var ProgressMsgId = "";
               
                if (data === 'SND') {
                    RRResponseVM.UploadComment($("#SummaryFileTextArea").val().trim());
                    errormsgId = '#lblRDErrorSummary';
                    ProgressBarMainDivId = '#ProgressBarMainDivSummary';
                    ProgressMsgId = '#lblProgressMsgSummary';
                    FileList = document.getElementById('SummaryFileUploader').files;
                    if (FileList.length > 0)
                        FileName = document.getElementById('SummaryFileUploader').files[0].name;
                }
                else {
                    //var editor = CKEDITOR.instances['UploadTextArea_' + data.QuestionId()].getData();
                    //RRResponseVM.UploadComment(editor);
                    RRResponseVM.UploadComment($("#UploadTextArea_" + data.RRItemId()).val().trim());
                    errormsgId = "#lblRDError_" + data.RRItemId();
                    $(errormsgId).hide();
                    ProgressBarMainDivId = "#ProgressBarMainDiv_" + data.RRItemId();
                    ProgressMsgId = "#lblProgressMsg_" + data.RRItemId();
                    FileList = document.getElementById('FileUploaderForDocuments_' + data.RRItemId()).files;
                    if (FileList.length > 0)
                        FileName = document.getElementById('FileUploaderForDocuments_' + data.RRItemId()).files[0].name;
                }
                if (FileList.length > 0) {
                    if (FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PNG'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'JPG'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'JPEG'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'DOCX'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'DOC'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLS'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PDF'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'CSV'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'TXT'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSX'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSM'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'BMP'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'RTF'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PPT'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PPTX'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'MSG') {

                        if (FileList[0].size <= 1073741824) {
                            if (RRResponseVM.UploadComment() != "" && RRResponseVM.UploadComment() != undefined) {
                                if (RRResponseVM.UploadComment().length <= RRResponseVM.CommentCharsLimit()) {
                                    $(errormsgId).text("");
                                    $(ProgressMsgId).removeClass('field-validation-error');
                                    var FormDataObj = new FormData();
                                    FormDataObj.append("File1", FileList[0]);
                                    var request = new XMLHttpRequest();
                                    $(ProgressBarMainDivId).show();
                                    request.onreadystatechange = function () {
                                        if (request.readyState == 1) {
                                            RRResponseVM.ProgressMessage("Initializing File Upload...");
                                        }
                                        else if (request.readyState == 4) {
                                            if (request.status == 200) {
                                                if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                                    RRResponseVM.ProgressMessage("The file has been uploaded successfully.");

                                                    var DocName = "";
                                                    if (data === 'SND') {
                                                        DocName = document.getElementById('SummaryFileUploader').files[0].name;
                                                        SetDocumentComments(-1, "SND", DocName, JSON.parse(request.response), RRResponseVM.UploadComment()).then(function () {
                                                            document.getElementById('SummaryFileUploader').value = '';
                                                            document.getElementById('SummaryFileTextArea').value = '';
                                                            GetSurveyLevelComments("SND");
                                                        });
                                                    }
                                                    else {
                                                        DocName = document.getElementById('FileUploaderForDocuments_' + data.RRItemId()).files[0].name;

                                                        SetDocumentComments(data.RRItemId(), "RD", DocName, JSON.parse(request.response), RRResponseVM.UploadComment()).then(function () {
                                                            document.getElementById('FileUploaderForDocuments_' + data.RRItemId()).value = '';
                                                            document.getElementById("UploadTextArea_" + data.RRItemId()).value = '';
                                                            //showCommentsRichText(data.QuestionId(), 'atch');
                                                            if (!RRResponseVM.IsDocumentPopUp()) {
                                                                GetComments(data.RRItemId(), "RD", null);
                                                            }
                                                            else
                                                                GetCommentsPopUp(data.RRItemId(), "RD", null);
                                                        });
                                                    }
                                                    $(ProgressBarMainDivId).hide();
                                                    RRResponseVM.UploadComment("");
                                                    //$('#ProgressBarDiv').hide();
                                                    RRResponseVM.ProgressMessage("");
                                                    RRResponseVM.RemainingChars(RRResponseVM.CommentCharsLimit());
                                                    logger.logSuccess('The file has been uploaded successfully.', 'Success', system.getModuleId(RRResponseVM), true);
                                                }
                                                else {
                                                    $(ProgressBarMainDivId).show();
                                                    $(ProgressMsgId).addClass('field-validation-error');
                                                    RRResponseVM.ProgressMessage("The file could not be uploaded.");

                                                }
                                            }
                                        }
                                        else
                                            ajaxFail(request, "");

                                    };
                                    request.upload.addEventListener('progress', function (event) {
                                        RRResponseVM.ProgressPercent(parseInt((event.loaded / event.total) * 100) + '%');
                                        RRResponseVM.ProgressMessage("Uploading File...");
                                    });
                                    request.withCredentials = true;
                                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                                    var headers = appsecurity.getSecurityHeaders();
                                    headers.__RequestVerificationToken = csrfToken;
                                    request.open('POST', '/api/Survey/FileUploadRR');
                                    request.setRequestHeader('Authorization', headers.Authorization);
                                    request.setRequestHeader('RT', headers.RT);
                                    request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                                    request.send(FormDataObj);
                                    logger.logMessage("The file has been uploaded successfully.");
                                    $(ProgressBarMainDivId).hide();
                                }
                                else
                                    $(errormsgId).text("Upload Comment cannot exceed " + RRResponseVM.CommentCharsLimit() + " characters.").show();
                            }
                            else
                                $(errormsgId).text("Please enter some comment related to the uploaded file.").show();
                        }
                        else
                            $(errormsgId).text("Upload file size cannot exceed " + (RRResponseVM.UploadFileSize() / 1048576) + " MB. Please try uploading a file of lesser size.");
                    }
                    else
                        $(errormsgId).text("Please select a valid file to upload.");
                }
                else
                    $(errormsgId).text("Please select a file to upload.");

                function ajaxFail(error, status) {

                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        RRResponseVM.DashboardVM.NavigatedFrom('Response');
                                        router.navigate("Landing", true);
                                    }
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in UploadDocuments() method in SurveyResponsePage.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadDocuments() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                };

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: UploadDocument() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

        }

        function EditQuestionComment(data) {
            try {
                var commentObject = "",
                    commentText = "",
                    responseId = "",
                    responseText = "";
                RRResponseVM.CurrentCommentID(data.CommentId());
                $('#ResponseId' + RRResponseVM.SelectedQuestionId()).attr('disabled', true);
                $('#lblRCError_' + RRResponseVM.SelectedQuestionId()).hide();
                if (data != undefined && data != null && data.CommentText() != undefined && data.CommentText().trim() != '') {
                    commentObject = data.CommentText().split(':');

                    if (commentObject != undefined && commentObject.length > 1) {
                        responseText = commentObject[0];
                    }

                }
                if (responseId != "")
                    $('#ResponseId' + RRResponseVM.SelectedQuestionId()).val(responseId);

                if (data.CommentText() !== "" && data.CommentText().length > 0) {
                    commentText = data.CommentText().substring(data.CommentText().indexOf(":") + 1);

                    if (commentText !== "" && commentText.length > 0) {
                        var commentVar = $('<div/>').html(commentText).text().trim();
                        $('#ResponseTextArea_' + RRResponseVM.SelectedQuestionId()).val(commentVar);
                        RRResponseVM.RemainingChars(RRResponseVM.CommentCharsLimit() - commentVar.length);
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: EditQuestionComment() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function DeleteQuestionComment(data) {
            try {
                app.showMessage('Are you sure you want to delete this comment?', 'Delete Comment', ['Confirm', 'Cancel'])
                    .then(function (option) {
                        if (option === 'Confirm') {
                            DeleteComment(data);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteQuestionComment() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function DeleteComment(data) {
            try {
                RRResponseVM.selectedTreeNode($('#jsTreeAreaLevel').treeview('getSelected'));
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingDashboard/DeleteDocComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        CommentId: data.CommentId(),
                        QuestionId: RRResponseVM.SelectedQuestionId(),
                        SPR_UID: RRResponseVM.SurveyId(),
                        CommentType: 'RC',
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | DeleteComment() in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(result, status) {
                try {
                    if (result >= 0) {

                        ko.utils.arrayFilter(RRResponseVM.SurveyResponseList(), function (item) {
                            if (item.RRItemId() == RRResponseVM.SelectedQuestionId()) {
                                    item.CommentCount(result);
                                }
                            });
                            if (RRResponseVM.IsCommentPopUp())
                                GetCommentsPopUp(RRResponseVM.SelectedQuestionId(), "RC", null);
                            else
                                GetComments(RRResponseVM.SelectedQuestionId(), "RC", null);



                        RRResponseVM.isSaveResponseClick(true);

                        logger.logSuccess('Comment deleted successfully.', 'Success', system.getModuleId(RRResponseVM), true);
                    }
                    else {
                        //logger.logError('An error occurred while deleting the comment.', 'Error', system.getModuleId(RRResponseVM), true);
                        var redirectBack = confirm("You are no longer allowed to perform Save/Edit operation. The Survey is either moved to another state or picked by another user. You will be redirected to Landing Page.");
                        if (redirectBack === true) {
                            RRResponseVM.SurveyDashBoard.NavigatedFrom('Response');
                            router.navigate("landing", true);
                        }
                        else {
                            app.showMessage("The Survey is either moved to another state or picked by another user. You are not allowed to perform Save/Edit operation. Please click 'OK' to redirect to Landing Page.", "Action cannot be performed", [" OK"], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                                .then(function (option) {
                                    if (option === " OK") {
                                        RRResponseVM.SurveyDashBoard.NavigatedFrom('Response');
                                        router.navigate("landing", true);
                                    }
                                });
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in DeleteComment() in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteComment() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteComment() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }
        function SetDocumentComments(QuestionId, CommentType, DocName, DocPath, CommentText) {
            try {
                RRResponseVM.selectedTreeNode($('#jsTreeAreaLevel').treeview('getSelected'));
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/RiskRatingDashboard/SetDocumentComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        QuestionId: QuestionId, SPR_UID: RRResponseVM.SurveyId(), SurveyType: RRResponseVM.SurveyClassification(), CommentType: CommentType, CommentText: CommentText, DocumentPath: DocPath, DocumentName: DocName
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult < 0) {
                            //logger.logError('An error occurred while saving the document. Please contact your Application Administrator.', 'Error', system.getModuleId(RRResponseVM), true);
                            var redirectBack = confirm("You are no longer allowed to perform Save/Edit operation. The Survey is either moved to another state or picked by another user. You will be redirected to Landing Page.");
                            if (redirectBack === true) {
                                RRResponseVM.SurveyDashBoard.NavigatedFrom('Response');
                                router.navigate("landing", true);
                            }
                            else {
                                app.showMessage("The Survey is either moved to another state or picked by another user. You are not allowed to perform Save/Edit operation. Please click 'OK' to redirect to Landing Page.", "Action cannot be performed", [" OK"], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                                    .then(function (option) {
                                        if (option === " OK") {
                                            RRResponseVM.SurveyDashBoard.NavigatedFrom('Response');
                                            router.navigate("landing", true);
                                        }
                                    });
                            }
                        }
                        else {
                            if (CommentType === "RD") {


                                ko.utils.arrayFilter(RRResponseVM.SurveyResponseList(), function (item) {
                                    if (item.RRItemId() == QuestionId) {
                                            item.DocumentCount(jsonResult);
                                        }
                                    });

                                RRResponseVM.isSaveResponseClick(true);

                            }

                        }


                    })
                    .fail(function () {

                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: UploadDocument() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }
        function DownloadDocument(data, event) {
            try {
                var DocumentInfo = data;
                var test = $.ajax({
                    url: "/api/RiskRatingDashboard/CheckFilePresence",
                    type: "Get",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { CommentId: data.DCommentId(), FilePath: data.DocumentPath(), FileName: data.DocumentName() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in DownloadDocument() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status, xhr) {
                try {

                    if (jsonResult) {
                        var payLoad = {
                            t: appsecurity.getAuthenticationInfo(), FilePath: data.DocumentPath(), FileName: data.DocumentName()
                        };
                        utils.postAndRedirect(rootPath + "/FileDownload/DownloadFileRR", payLoad, '_blank');
                    }
                    else
                        logger.logError('The requested document is not available for download. Please contact your Application Administrator.', 'Error', system.getModuleId(RRResponseVM), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DownloadDocument() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DownloadDocument() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DownloadDocument() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };

        }
        function DeleteDocument(data, commentType) {
            try {
                if (commentType !== "SND") {
                    commentType = "RD";
                }
                app.showMessage('Are you sure you want to delete this document?', 'Delete Document', ['Confirm', 'Cancel'])
                    .then(function (option) {
                        if (option === 'Confirm') {
                            DeleteResponseDocument(data, commentType);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteControlQuestionPopUp() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function DeleteResponseDocument(data, commentType) {
            try {
                if (commentType === "RD")
                    RRResponseVM.selectedTreeNode($('#jsTreeAreaLevel').treeview('getSelected'));
                var DocumentInfo = data;
                var test = $.ajax({
                    url: "/api/RiskRatingDashboard/CheckFilePresence?CommentId=" + data.DCommentId() + "&FileName=" + data.DocumentName() + "&FilePath=" + data.DocumentPath(),
                    type: "Get",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in DeleteDocument() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status, xhr) {
                try {
                    if (jsonResult) {
                        DeleteDocComments(data, commentType);
                    }
                    else
                        logger.logError('The requested document is not available to delete. Please contact your Application Administrator.', 'Error', system.getModuleId(RRResponseVM), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DeleteDocument() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteDocument() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteDocument() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };

        }

        function DeleteDocComments(data, commentType) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingDashboard/DeleteDocComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        CommentId: data.DCommentId,
                        QuestionId: RRResponseVM.SelectedQuestionId(),
                        SPR_UID: RRResponseVM.SurveyId(),
                        CommentType: commentType,
                        SurveyType: RRResponseVM.SurveyClassification()
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | DeleteDocComments() in SurveyDashboard.js'
                logger.logMessage(msg);
            }
            function ajaxSuccess(result, status) {
                try {

                    if (result >= 0) {
                        DeleteFile(data, result, commentType);
                    }
                    else {
                        //logger.logError('An error occurred while deleting the document.', 'Error', system.getModuleId(RRResponseVM), true);
                        var redirectBack = confirm("You are no longer allowed to perform Save/Edit operation. The Survey is either moved to another state or picked by another user. You will be redirected to Landing Page.");
                        if (redirectBack === true) {
                            RRResponseVM.SurveyDashBoard.NavigatedFrom('Response');
                            router.navigate("landing", true);
                        }
                        else {
                            app.showMessage("The Survey is either moved to another state or picked by another user. You are not allowed to perform Save/Edit operation. Please click 'OK' to redirect to Landing Page.", "Action cannot be performed", [" OK"], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                                .then(function (option) {
                                    if (option === " OK") {
                                        RRResponseVM.SurveyDashBoard.NavigatedFrom('Response');
                                        router.navigate("landing", true);
                                    }
                                });
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in DeleteDocComments() in SurveyResponse.js'
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteDocComments() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteDocComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }


        function SaveResponse(data) {
            try {
               // ClearSearchText();
                RRResponseVM.isSaveResponseClick(true);
              //  RRResponseVM.EnableMandatoryFlags(true);
                RRResponseVM.saveEventId(event.currentTarget.id);
                RRResponseVM.selectedTreeNode($('#jsTreeAreaLevel').treeview('getSelected'));
                        SaveQuantResposne().then(function () {

                            //if (RRResponseVM.NavigateToDashboardBoolean()) {
                            //    RRResponseVM.isSaveResponseClick(false);
                            //    RRResponseVM.SurveyDashBoard.NavigatedFrom('Response');
                            //    router.navigate('Landing', true);
                            //}
                            //else {
                            //    if (RRResponseVM.saveEventId() === "onPageSavebtn") {
                            //        //ReloadTabafterSaveMain(data);
                            //        RRResponseVM.saveEventId('');
                            //    }
                            //    else
                            //        //ReloadTabafterDirtyCheckSave(data);
                            //}
                        });
                RRResponseVM.ValuesChanged(false);


            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveResponse() method SetSurveyCommentsin SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }
        function SaveQuantResposne(data) {
            try {
                var JsonList = ConstructQualJsonList();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/RiskRatingDashboard/SetRRSurveyQuestionnaire",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    dataType: 'json',
                    data: ko.toJSON({
                        QuestionResponseTypes: JsonList,
                        SurveyProfileRelId: RRResponseVM.SurveyId()
                    })
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult == null) {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RRResponseVM), true);
                        }
                        else if (jsonResult <= 0) {
                            var redirectBack = confirm("You are no longer allowed to perform Save/Edit operation. The Survey is either moved to another state or picked by another user. You will be redirected to Landing Page.");
                            if (redirectBack === true) {
                                RRResponseVM.SurveyDashBoard.NavigatedFrom('Response');
                                router.navigate("landing", true);
                            }
                            else {
                                app.showMessage("The Survey is either moved to another state or picked by another user. You are not allowed to perform Save/Edit operation. Please click 'OK' to redirect to Landing Page.", "Action cannot be performed", [" OK"], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                                    .then(function (option) {
                                        if (option === " OK") {
                                            RRResponseVM.SurveyDashBoard.NavigatedFrom('Response');
                                            router.navigate("landing", true);
                                        }
                                    });
                            }
                            //logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RRResponseVM), true);
                        }
                        else {
                            logger.logSuccess('Responses have been saved successfully.', 'Success', system.getModuleId(RRResponseVM), true);
                            //BindQuantiativeTable();
                        }
                    })
                    .fail(function (fail, error) {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RRResponseVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveQuantResposne() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ConstructQualJsonList() {
            try {
                var MainList = [];
                var ResponseTextValue = '';

                for (var i = 0; i < RRResponseVM.SurveyResponseList().length; i++) {
                    for (var j = 0; j < RRResponseVM.SurveyResponseList()[i].QuestionsList.length; j++) {

                        ResponseTextValue = RRResponseVM.SurveyResponseList()[i].QuestionsList[j].SelectedResponse();
                        var tempObject = {
                            RRItemId: RRResponseVM.SurveyResponseList()[i].RRItemId(), QuestionId: RRResponseVM.SurveyResponseList()[i].QuestionsList[j].QuestionId(),
                            ResponseId: ResponseTextValue, ResponseTypeId: RRResponseVM.SurveyResponseList()[i].QuestionsList[j].ResponseTypeId()
                        }
                        MainList.push(tempObject)
                    }
                }
                    return MainList;


            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ConstructJsonList() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function DeleteFile(data, DocCount, commentType) {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingDashboard/DeleteFile",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        DocumentPath: data.DocumentPath(),
                        DocumentName: data.DocumentName()
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);

            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | DeleteDocComments() in SurveyDashboard.js'
                logger.logMessage(msg);
            }

            function ajaxSuccess(result, status) {
                try {
                    if (result.toLowerCase() == 'ok') {
                        logger.logSuccess('Document deleted successfully.', 'Success', system.getModuleId(RRResponseVM), true);
                        if (commentType === 'RD') {
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();


                            ko.utils.arrayFilter(RRResponseVM.SurveyResponseList(), function (item) {
                                if (item.RRItemId() == RRResponseVM.SelectedQuestionId()) {
                                        item.DocumentCount(DocCount);
                                    }
                                });
                                if (RRResponseVM.IsDocumentPopUp())
                                    GetCommentsPopUp(RRResponseVM.SelectedQuestionId(), "RD", null);
                                else
                                    GetComments(RRResponseVM.SelectedQuestionId(), "RD", null);


                            RRResponseVM.isSaveResponseClick(true);
                           // SegregatorBasedOnSurveyType();
                        }
                        else {
                            GetSurveyLevelComments("SND");
                        }
                    }
                    else
                        logger.logError('An error occurred while deleting the document.', 'Error', system.getModuleId(RRResponseVM), true);
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in DeleteDocComments() in SurveyResponse.js'
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteDocComments() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteDocComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }

        }

        // #region Export-Import and SSRS Excels

        function ExportSurveyToExcel(data, event) {
            try {
                var UserString = "Assigned Users: ";
                if (RRResponseVM.UserList() != null || RRResponseVM.UserList() != "")
                    UserString = UserString + RRResponseVM.UserList().replace(/(<p>|<\/p>|<strong class='lbl-space'>|<strong>|<\/strong>|<em>|<\/em>|<u>|<\/u>|<ol>|<\/ol>|<ul>|<\/ul>|<li>|<\/li>)/gi, "").replace(/(\r\n|\n|\r)/gm, " ");
                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), SurveyID: RRResponseVM.SurveyId()
                    , SurveyName: $('<div/>').html(RRResponseVM.SurveyName()).text(), DueDate: 'Completion Due Date: ' + RRResponseVM.DueDate(), UserList: UserString.toString(), SurveyProfileID: RRResponseVM.SurveyProfileId()
                };

                utils.postAndRedirect(rootPath + "/FileDownload/ExportExcelRRSurvey", payLoad, '_blank');


            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | ExportSurveyToExcel() in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ImportExcelPopUp(data, event) {
            try {
                document.getElementById('ImportSurveyError').innerHTML = "";
                document.getElementById('FileUploader').value = '';
                $('#Exportexcel').modal('show');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ImportExcelPopUp() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function UploadExcelDocument(data, event) {
            try {
                $('#ImportSurveyError').show();
                var FileList = document.getElementById('FileUploader').files;
                if (FileList.length > 0) {
                    var FileName = document.getElementById('FileUploader').files[0].name;
                    if (FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() === 'XLSX' || FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() === 'XLSM') {
                        if (FileList[0].size <= 1073741824) {

                            document.getElementById('ImportSurveyError').innerHTML = "";

                            var FormDataObj = new FormData();
                            FormDataObj.append("File1", FileList[0]);
                            var request = new XMLHttpRequest();

                            request.onreadystatechange = function () {
                                if (request.readyState === 1) {
                                    document.getElementById('ImportSurveyError').innerHTML = "Initializing File Upload...";
                                    $('#ImportSurveyError').show();
                                }
                                else if (request.readyState === 4) {
                                    if (request.status === 200) {
                                        if (request.responseText !== null && request.responseText !== "" && request.responseText !== "null") {
                                            if (request.responseText === "2") {
                                                document.getElementById('ImportSurveyError').innerHTML = "Error in file upload";
                                                logger.logWarning('Excel format mismatch. Please check and try again.', 'Warning', system.getModuleId(RRResponseVM), true);
                                                $('#ImportSurveyError').show();
                                                var DocName = document.getElementById('FileUploader').files[0].name;
                                                document.getElementById('FileUploader').value = '';
                                                $('#Exportexcel').modal('hide');
                                                $('body').removeClass('modal-open');
                                                $('.modal-backdrop').remove();
                                            }
                                            else if (request.responseText === "-1") {

                                                document.getElementById('ImportSurveyError').innerHTML = "Error in file upload";
                                                logger.logWarning('Incorrect Excel file. Please check and try again.', 'Warning', system.getModuleId(RRResponseVM), true);
                                                $('#ImportSurveyError').show();
                                                var DocName = document.getElementById('FileUploader').files[0].name;
                                                document.getElementById('FileUploader').value = '';
                                                $('#Exportexcel').modal('hide');
                                                $('body').removeClass('modal-open');
                                                $('.modal-backdrop').remove();

                                            }
                                            else {
                                                document.getElementById('ImportSurveyError').innerHTML = "The file has been uploaded successfully.";
                                                logger.logSuccess('Responses Uploaded Successfully ', 'Success', system.getModuleId(RRResponseVM), true);
                                                $('#ImportSurveyError').show();
                                                var DocName = document.getElementById('FileUploader').files[0].name;
                                                document.getElementById('FileUploader').value = '';

                                               // ClearSearchText();
                                                RRResponseVM.isSaveResponseClick(true);
                                                RRResponseVM.EnableMandatoryFlags(true);
                                                RRResponseVM.saveEventId(event.currentTarget.id);
                                                RRResponseVM.selectedTreeNode($('#jsTreeAreaLevel').treeview('getSelected'));
                                                GetSurveyColumnDetails().then(function () {
                                                    BindSurveyTable();
                                                });

                                                //if (RRResponseVM.ClickedRiskAreaId() !== -1000) {
                                                //    // refreshing the treeview along with new data load
                                                //    $('#QualContDynamicHTMLDiv').html("");
                                                //    $('#DynamicHTMLDiv').html("");
                                                //    ReloadTabafterSaveMain();
                                                //}
                                                //else {
                                                //    // for MCI - refreshing only the treeview
                                                //    SegregatorBasedOnSurveyType();
                                                //}

                                                $('#Exportexcel').modal('hide');
                                                $('body').removeClass('modal-open');
                                                $('.modal-backdrop').remove();
                                            }
                                        }
                                        else {


                                            document.getElementById('ImportSurveyError').innerHTML = "The file could not be uploaded.";
                                            logger.logError('Some Error Occured while Uploading Report.', 'Error', system.getModuleId(RRResponseVM), true);
                                            $('#ImportSurveyError').show();
                                            document.getElementById('FileUploader').value = '';
                                            $('#Exportexcel').modal('hide');
                                            $('body').removeClass('modal-open');
                                            $('.modal-backdrop').remove();

                                        }
                                    }
                                    else {
                                        //ajaxFail(request, "");
                                        if (request.status === 401) {
                                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                                .then(function (option) {
                                                    if (option === "OK") {
                                                        RRResponseVM.DashboardVM.NavigatedFrom('Response');
                                                        router.navigate("#Landing", true);
                                                    }

                                                });
                                        }
                                        else {
                                            var msg = 'Exception: ' + request.responseText + ' | Source: ajaxFail in UploadDocument() method in SurveyResponsePage.js';
                                            logger.logMessage(msg);
                                        }
                                    }
                                }
                            };
                            request.upload.addEventListener('progress', function (event) {
                                document.getElementById('ImportSurveyError').innerHTML = "Uploading File...";
                            });
                            request.withCredentials = true;

                            request.open('POST', "/api/Survey/UploadExcelSurveyPCS? &SurveyId=" + RRResponseVM.SurveyId());

                            var csrfToken = $("input[name='__RequestVerificationToken']").val();
                            var headers = appsecurity.getSecurityHeaders();
                            headers.__RequestVerificationToken = csrfToken;
                            request.setRequestHeader('Authorization', headers.Authorization);
                            request.setRequestHeader('RT', headers.RT);
                            request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                            request.send(FormDataObj);

                        }
                        else
                            document.getElementById('ImportSurveyError').innerHTML = "Upload File Size cannot exceed " + (RRResponseVM.UploadFileSize() / 1048576) + " MB. Please Try Uploading a file of lesser size.";
                    }
                    else
                        document.getElementById('ImportSurveyError').innerHTML = "Please Select Valid File to Upload";
                }

                else
                    document.getElementById('ImportSurveyError').innerHTML = "Please Select a File to Upload";

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadExcelDocument() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

       //  #endregion
        //function showOverallSummaryDiv() {
        //    try {
        //        $('#OverallSummaryDiv').modal('show');
        //      //  GetSurveyLevelComments("SND");
        //        RRResponseVM.RemainingChars(RRResponseVM.CommentCharsLimit());
        //        var editor = CKEDITOR.instances['NarrationTextArea'];
        //        if (editor) {
        //            editor.destroy(true);
        //        }
        //        CKEDITOR.replace('NarrationTextArea', {
        //            removePlugins: RRResponseVM.RemovePlugins(),
        //            removeButtons: RRResponseVM.RemoveButtons()
        //        });
        //        //CKEDITOR.instances['NarrationTextArea'].on('key', function () {
        //        //    ckeCharCheck();
        //        //});
        //        $('#NarrationTextArea').html(RRResponseVM.SurveySummaryComment());
        //        //ckeCharCheck();
        //    }
        //    catch (e) {
        //        var msg = 'Exception: ' + e + ' | Source: showOverallSummaryDiv() method in SurveyResponsePage.js';

        //        logger.logMessage(msg);
        //    }
        //}

        function InitiateLevelTree() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getJsTreeAreaLevel = {

                    url: "/api/RiskRatingConfiguration/GetSurveyResponseTForRR",
                    type: "GET",
                    headers: headers,
                    data: { ProfileId: RRResponseVM.SurveyId()}
                };
                $.ajax(getJsTreeAreaLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in InitiateLevelTree() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                if (jsonResult != null) {
                    //implement js tree logic here
                    RRResponseVM.AreaLeveljstree(jsonResult.AreaLevelsData);

                    var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {

                        return new jsTreeModel(result);

                    });
                    $('#jsTreeAreaLevel').treeview({
                        data: MappedJsTreeList,
                        onNodeSelected: nodeClickEvent
                    });

                    var hasChildNodes = ko.utils.arrayFilter(MappedJsTreeList, function (i) { if (i.dead_node != 1) { return i; } }).length > 0
                    RRResponseVM.hasChildNodes(hasChildNodes);

                    //for initial load expand for treeview
                    $("#jsTreeAreaLevel ul:first li:first").trigger("click");
                    $("loadingImgOrCalc").hide();
                    $("loadingMainImgDivTh").hide();
                    $("loadingImgMainTh").hide();
                }
                else {
                    $('#error').show();
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in InitiateLevelTree() method in AMLThresholds.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in InitiateLevelTree() method in AMLThresholds.js';
                    logger.logMessage(msg);
                }
            }

            function filterJsTree(TreeStructure) {

                return TreeStructure.filter(
                    function (item) {
                        if (item.nodes != undefined && item.nodes.length > 0) {
                            item.nodes = filterJsTree(item.nodes);
                        }

                        if (item.showLevel == 1)
                            return true;
                        else
                            return false;

                    }
                );
            }


            function nodeClickEvent(event, node) {
                // Your logic goes here

                    //select node explicitly in case of recursive calling activity.
                    $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);

                RRResponseVM.ClickedRiskFactorId(parseInt(node.id));
                RRResponseVM.ProductName(node.text);
                    GetSurveyColumnDetails().then(function () {
                        BindSurveyTable();
                    });
                    $('#loadingMainImgDivFactors').show();
                    //   RRResponseVM.SelectedAreaName(node.text);
                    // RRResponseVM.CurrentRiskAreaType(node.assessmentTypeList());
                    //GetRiskFactors(parseInt(node.id));


            }


            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };
        }

        function NavigateToDashboard(data) {
            try {

                if (RRResponseVM.PreviousPage().toLowerCase() == "tracking") {
                    RRResponseVM.ObjGeneralSettings.NavPillIdSurveyTracking(RRResponseVM.SurveyTrackingVM.NavPillId());
                    RRResponseVM.ObjGeneralSettings.isNavigatedBackFromSurveyResponsePage(true);
                    router.navigate('survey/SurveyTracking', true);
                }

                //else if (RRResponseVM.PreviousPage().toLowerCase() == "dashboard" && RRResponseVM.SurveyStatus() != 'Survey Review - Pending' && RRResponseVM.SurveyStatus() != 'Completed' && RRResponseVM.ValuesChanged()) {
                //    app.showMessage("Please save the data before moving back to Dashboard, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn", primaryButtonClass: "primary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                //        .then(function (option) {
                //            RRResponseVM.ValuesChanged(false);
                //            RRResponseVM.isSaveResponseClick(false);
                //            if (option == "Save") {
                //                RRResponseVM.SavechangedvalueTab(null);
                //                RRResponseVM.SavechangedvalueSubTab(null);
                //                RRResponseVM.NavigateToDashboardBoolean(true);
                //                if (RRResponseVM.MCILevel() == true) {
                //                    SetMCI_LevelDetails();
                //                } else {
                //                    SaveResponse(data);
                //                }
                //            }
                //            else {
                //                RRResponseVM.DashboardVM.NavigatedFrom('Response');
                //                router.navigate('Landing', true);
                //            }
                //        })
                //}
                else if (RRResponseVM.PreviousPage().toLowerCase() == "dashboard") {
                    RRResponseVM.SurveyDashBoard.NavigatedFrom('Response');
                    router.navigate('Landing', true);
                }
                else
                    router.navigate('survey/SurveyTracking', true);

                RRResponseVM.ValuesChanged(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateToDashboard() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }
        function GetSurveyColumnDetails() {
            try {
                return $.ajax({
                    url: "/api/RiskRatingDashboard/GetRRSurveyColumnDetails",
                    data: { FactorId: RRResponseVM.ClickedRiskFactorId(), ProfileId: RRResponseVM.SurveyId() },
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (JsonResult, Success) {
                        RRResponseVM.SurveyColumnDetails([]);
                        var MappedColumnObject = $.map(JsonResult, function (result) {
                            return new SurveyColumnDetailsModel(result);
                        });
                        RRResponseVM.SurveyColumnDetails(MappedColumnObject);
                    })
                    .fail(function (Error, fail) {
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetSurveyColumnDetails() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function BindSurveyTable() {
            try {
                $.ajax({
                    url: "/api/RiskRatingDashboard/GetRRProductQuestionDetails",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { SelectedFactorId: RRResponseVM.ClickedRiskFactorId(), ProfileId: RRResponseVM.SurveyId() }
                })
                    .success(function (JsonResult, Success) {

                        if (JsonResult != null) {
                            tableObj = $('#tblSurveyConfig').DataTable();
                            tableObj.destroy();
                            $('#tblSurveyConfig tbody tr').remove();
                            var MappedColumnObject = $.map(JsonResult, function (result) {
                                return new QuantitativeResponseModel(result);
                            });

                            RRResponseVM.SurveyResponseList(MappedColumnObject);
                            var oTable = $('#tblSurveyConfig').DataTable(
                                {
                                    'aoColumnDefs': [{
                                        'bSortable': false,
                                        "targets": "_all"
                                    }],
                                    "aaSorting": [],
                                    "bResponsive": true,
                                    scrollY: "380px",
                                    scrollX: "380px",
                                    paging: false,
                                    bFilter: true,
                                    "bInfo": false,
                                    fixedColumns: {
                                        leftColumns: 1
                                    },
                                    fixedheader: {
                                        header: true
                                    }

                                });
                          //  $('#tblSurveyConfig').DataTable().draw(false);
                           // $('#tblSurveyConfig').closest(".dataTables_wrapper").find("*").css("box-sizing", "content-box").css("-moz-box-sizing", "content-box");


                        }


                        $('#loadingImgUser').hide().removeClass("d-inline-flex").addClass("d-none");
                        $('#SyncRatingsRefreshBtn').show();
                        $('#syncRatingsBtn').prop('disabled', false);

                    })
                    .fail(function (fail, error) {
                        $('#LoadingGIFSRDiv').hide();
                        $('#loadingImgUser').hide().removeClass("d-inline-flex").addClass("d-none");
                        $('#SyncRatingsRefreshBtn').show();
                        $('#syncRatingsBtn').prop('disabled', false);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BindQuantiativeTable() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }


        //#region Model Definitions

        function QuantitativeResponseModel(item) {
            try {
                var self = this;
                self.DisplayRank = ko.observable(item.RRItemRank);
                self.SortOrder = ko.observable(item.RRItemRank);
                self.Is_Header = ko.observable(item.Is_Header);
                self.RRItemId = ko.observable(item.RRItemId);

                self.IsReadOnly = ko.observable(0); // No ReadOnly flag is present in Backend. Coded to facilitate ReadOnly functionality if required in future.
                self.RRItemName = ko.observable($('<div/>').html(item.RRItemName).text());
                self.CommentCount = ko.observable(item.CommentCount);
                self.DocumentCount = ko.observable(item.DocumentCount);

                self.IsVisibleforSearch = ko.observable(true);
              //  self.InfoGuidelineComment = ko.observable(item.InfoGuidelineComment); // (item.InfoGuidelineComment);
                self.cmt_hrefId = ko.observable('#cmt_' + item.RRItemId);
                self.attachment_hrefId = ko.observable('#atch_' + item.RRItemId);
                self.guideline_hrefId = ko.observable('#gui_' + item.RRItemId);
                self.hist_hrefId = ko.observable('#hist_' + item.RRItemId);

                self.cmtId = ko.observable('cmt_' + item.RRItemId);
                self.attachmentId = ko.observable('atch_' + item.RRItemId);
                self.guidelineId = ko.observable('gui_' + item.RRItemId);
                self.histId = ko.observable('hist_' + item.RRItemId);

                self.Is_CommentMandatory = ko.observable(item.Is_CommentMandatory);
                self.Is_DocumentMandatory = ko.observable(item.Is_DocumentMandatory);
                self.Is_ResponseMandatory = ko.observable(item.Is_ResponseMandatory);
                self.IndentationValue = ko.observable(item.IndentationValue);
                var mappedQuestionList = $.map(item.QuestionsList, function (result) {
                    return ResponseObject = new QuestionListModel(result);
                });
                self.QuestionsList = mappedQuestionList;
                self.ShowQuestionMandatoryFlag = ko.observable(item.ShowQuestionMandatoryFlag);
                self.IsSaveClicked_Response = ko.observable(false);
                self.IsSaveClicked_Comment = ko.observable(false);
                self.IsSaveClicked_Document = ko.observable(false);
                self.bmFlagID = ko.observable('bmFlag_' + item.QuestionId);
                self.BookmarkFlagQuestion = ko.observable(item.BookmarkFlagQuestion);
                self.TotalScore = ko.observable(item.TotalScore);
                self.RiskLevel = ko.observable(item.RiskLevel);
                self.RiskCSS = ko.observable(item.RiskCSS);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: QuantitativeResponseModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ResponseListModel(item) {
            var self = this;
            self.RRResponseTypeId = ko.observable(item.RRResponseTypeId);
            self.RRResponseTypeName = ko.observable(item.RRResponseTypeName);
            self.ParentQuestionId = ko.observable(item.RRQuestionId_Response);

        }
        function ValidationListObject(item) {
            try {
                var self = this;
                self.QuestionId = ko.observable(item.QuestionId);
                self.DisplayRank = ko.observable(item.DisplayRank);
                self.Factor = ko.observable($('<div/>').html(item.RRItemName).text());
                self.QuestionText = ko.observable($('<div/>').html(item.Question).text());
                self.MandatoryFieldType = ko.observable($('<div/>').html(item.MandatoryField).text());
                self.MandatoryFieldFlag = ko.observable(item.MandatoryFieldFlag);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ValidationListObject() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function QuestionListModel(item) {
            var self = this;
            self.QuestionId = ko.observable(item.QuestionId);
            self.ParentQuestionId = ko.observable(item.RRItemId_Ques);
            self.QuestionName = ko.observable(item.QuestionName);
            self.RRQuestionApplicable = ko.observable(item.RRQuestionApplicable);
            self.ResponseTypeId = ko.observable(item.ResponseTypeId);
            var mappedResposneList = $.map(item.ResponseList, function (result) {
                return ResponseObject = new ResponseListModel(result);
            });
            self.ResponseList = mappedResposneList;
            self.SelectedResponse = ko.observable(item.SelectedResponse);;
        }

        function JobStatusModel(item) {
            try {
                var self = this;
                self.JobId = ko.observable(item.JobId);
                self.JobRunDate = ko.observable(item.JobRunDate);
                self.JobRunBy = ko.observable(item.JobRunBy);
                self.JobType = ko.observable(item.JobType);
                self.JobRunStatus = ko.observable(item.JobStatus);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: JobStatusModel() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
        }

        function DocumentCommentModel(item) {
            try {
                var self = this;
                self.DCommentText = ko.observable(item.CommentText);
                self.DCommentId = ko.observable(item.CommentId);
                self.DUploadedBy = ko.observable(item.UploadedBy);
                self.DUploadedDate = ko.observable(item.UploadedDate);
                self.DIsCurrentUser = ko.observable(item.IsCurrentUser);
                self.DocumentName = ko.observable(item.DocumentName);
                self.DocumentPath = ko.observable(item.DocumentPath);
                self.SurveyCompletionPercentage = ko.observable(item.SurveyCompletionPercentage);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DocumentCommentModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SurveyActionsModel(item) {
            try {
                var self = this;
                self.EventId = ko.observable(item.EventId);
                self.EventName = ko.observable($('<div/>').html(item.EventName).text());
                self.NextState = ko.observable($('<div/>').html(item.NextState).text());
                self.ShowValidatePopup = ko.observable(item.ShowValidatePopup);
                self.IsMessage = ko.observable(item.IsMessage);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyActionsModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function jsTreeModel(item) {
            var self = this;

            self.id = item.AreaLevelId.toString();
            self.text = item.AreaLevelName;
            if (RRResponseVM.AreaLeveljstree()[self.id].length > 0) {
                self.nodes = $.map(RRResponseVM.AreaLeveljstree()[self.id], function (result) {
                    return new jsTreeModel(result);
                });
            }
            self.ParentAreaLevelId = item.ParentAreaLevelId;
            self.state = { expanded: false };
            self.dead_node = item.DeadNode;
            self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
            self.RA_Type = ko.observable(item.RA_Type);
            self.IsBlueprintApplied = ko.observable(item.IsBlueprintApplied);

        }

        function SurveyColumnDetailsModel(item) {
            try {
                var self = this;
                self.RRColumnId = ko.observable(item.RRColumnId);
                self.RRColumnName = ko.observable($('<div/>').html(item.RRColumnName).text());
                self.RROptionType = ko.observable(item.RROptionType);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: QuanColumnDetailsModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }
        // #endregion
    });
